// ESPN CDN team logo URLs
// Format: https://a.espncdn.com/i/teamlogos/{sport}/500/{abbr}.png

import { getCountryFlagUrl } from './countryFlag'

const NHL_ABBRS = {
  'Anaheim Ducks': 'ana', 'Arizona Coyotes': 'ari', 'Boston Bruins': 'bos',
  'Buffalo Sabres': 'buf', 'Calgary Flames': 'cgy', 'Carolina Hurricanes': 'car',
  'Chicago Blackhawks': 'chi', 'Colorado Avalanche': 'col', 'Columbus Blue Jackets': 'cbj',
  'Dallas Stars': 'dal', 'Detroit Red Wings': 'det', 'Edmonton Oilers': 'edm',
  'Florida Panthers': 'fla', 'Los Angeles Kings': 'la', 'Minnesota Wild': 'min',
  'Montreal Canadiens': 'mon', 'Montréal Canadiens': 'mon',
  'Nashville Predators': 'nsh', 'New Jersey Devils': 'njd',
  'New York Islanders': 'nyi', 'New York Rangers': 'nyr', 'Ottawa Senators': 'ott',
  'Philadelphia Flyers': 'phi', 'Pittsburgh Penguins': 'pit', 'San Jose Sharks': 'sj',
  'Seattle Kraken': 'sea', 'St. Louis Blues': 'stl', 'St Louis Blues': 'stl',
  'Tampa Bay Lightning': 'tb', 'Toronto Maple Leafs': 'tor',
  'Utah Hockey Club': 'uta', 'Utah Mammoth': 'uta',
  'Vancouver Canucks': 'van', 'Vegas Golden Knights': 'vgk', 'Washington Capitals': 'wsh',
  'Winnipeg Jets': 'wpg',
}

const NBA_ABBRS = {
  'Atlanta Hawks': 'atl', 'Boston Celtics': 'bos', 'Brooklyn Nets': 'bkn',
  'Charlotte Hornets': 'cha', 'Chicago Bulls': 'chi', 'Cleveland Cavaliers': 'cle',
  'Dallas Mavericks': 'dal', 'Denver Nuggets': 'den', 'Detroit Pistons': 'det',
  'Golden State Warriors': 'gs', 'Houston Rockets': 'hou', 'Indiana Pacers': 'ind',
  'LA Clippers': 'lac', 'Los Angeles Clippers': 'lac', 'Los Angeles Lakers': 'lal',
  'LA Lakers': 'lal', 'Memphis Grizzlies': 'mem', 'Miami Heat': 'mia',
  'Milwaukee Bucks': 'mil', 'Minnesota Timberwolves': 'min', 'New Orleans Pelicans': 'no',
  'New York Knicks': 'ny', 'Oklahoma City Thunder': 'okc', 'Orlando Magic': 'orl',
  'Philadelphia 76ers': 'phi', 'Phoenix Suns': 'phx', 'Portland Trail Blazers': 'por',
  'Sacramento Kings': 'sac', 'San Antonio Spurs': 'sa', 'Toronto Raptors': 'tor',
  'Utah Jazz': 'utah', 'Washington Wizards': 'wsh',
}

const MLB_ABBRS = {
  'Arizona Diamondbacks': 'ari', 'Atlanta Braves': 'atl', 'Baltimore Orioles': 'bal',
  'Boston Red Sox': 'bos', 'Chicago Cubs': 'chc', 'Chicago White Sox': 'chw',
  'Cincinnati Reds': 'cin', 'Cleveland Guardians': 'cle', 'Colorado Rockies': 'col',
  'Detroit Tigers': 'det', 'Houston Astros': 'hou', 'Kansas City Royals': 'kc',
  'Los Angeles Angels': 'laa', 'Los Angeles Dodgers': 'lad', 'Miami Marlins': 'mia',
  'Milwaukee Brewers': 'mil', 'Minnesota Twins': 'min', 'New York Mets': 'nym',
  'New York Yankees': 'nyy', 'Oakland Athletics': 'oak', 'Athletics': 'oak', 'Philadelphia Phillies': 'phi',
  'Pittsburgh Pirates': 'pit', 'San Diego Padres': 'sd', 'San Francisco Giants': 'sf',
  'Seattle Mariners': 'sea', 'St. Louis Cardinals': 'stl', 'St Louis Cardinals': 'stl',
  'Tampa Bay Rays': 'tb', 'Texas Rangers': 'tex', 'Toronto Blue Jays': 'tor',
  'Washington Nationals': 'wsh',
}

const NFL_ABBRS = {
  'Arizona Cardinals': 'ari', 'Atlanta Falcons': 'atl', 'Baltimore Ravens': 'bal',
  'Buffalo Bills': 'buf', 'Carolina Panthers': 'car', 'Chicago Bears': 'chi',
  'Cincinnati Bengals': 'cin', 'Cleveland Browns': 'cle', 'Dallas Cowboys': 'dal',
  'Denver Broncos': 'den', 'Detroit Lions': 'det', 'Green Bay Packers': 'gb',
  'Houston Texans': 'hou', 'Indianapolis Colts': 'ind', 'Jacksonville Jaguars': 'jax',
  'Kansas City Chiefs': 'kc', 'Las Vegas Raiders': 'lv', 'Los Angeles Chargers': 'lac',
  'Los Angeles Rams': 'lar', 'Miami Dolphins': 'mia', 'Minnesota Vikings': 'min',
  'New England Patriots': 'ne', 'New Orleans Saints': 'no', 'New York Giants': 'nyg',
  'New York Jets': 'nyj', 'Philadelphia Eagles': 'phi', 'Pittsburgh Steelers': 'pit',
  'San Francisco 49ers': 'sf', 'Seattle Seahawks': 'sea', 'Tampa Bay Buccaneers': 'tb',
  'Tennessee Titans': 'ten', 'Washington Commanders': 'wsh',
}

const WNBA_ABBRS = {
  'Atlanta Dream': 'atl', 'Chicago Sky': 'chi', 'Connecticut Sun': 'conn',
  'Dallas Wings': 'dal', 'Golden State Valkyries': 'gs', 'Indiana Fever': 'ind',
  'Las Vegas Aces': 'lv', 'Los Angeles Sparks': 'la', 'Minnesota Lynx': 'min',
  'New York Liberty': 'ny', 'Phoenix Mercury': 'phx', 'Portland Fire': 'por',
  'Seattle Storm': 'sea', 'Toronto Tempo': 'tor', 'Washington Mystics': 'wsh',
}

// NCAA uses numeric ESPN team IDs (one id per school across CFB, MBB,
// WBB). Auto-generated from ESPN team endpoints — the map covers all
// D1 + most D2/D3 schools ESPN tracks, so a game between any covered
// schools renders logos in every sport that uses NCAA_IDS below.
const NCAA_IDS = {
  // ── Odds-feed name variants ──────────────────────────────────────────
  // Our games rows carry the odds provider's spelling, which doesn't always
  // match ESPN's canonical displayName used for the keys below. Each of
  // these rendered a blank circle instead of a logo. Found by diffing every
  // distinct NCAAF team name in `games` against this map; all 10 point at
  // ids already present here under a different name, and every URL was
  // HEAD-checked 200 on both the -dark and standard variants.
  //
  // "Albany" is UAlbany (399), not Albany State (2013) — 2013 is Division
  // II and never appears on a betting line. The game that surfaced this was
  // Albany @ Buffalo, and it's UAlbany who plays Buffalo.
  "Albany": 399,
  "Appalachian State Mountaineers": 2026,      // ESPN: "App State Mountaineers"
  "Citadel Bulldogs": 2643,                    // ESPN: "The Citadel Bulldogs"
  "Houston Baptist Huskies": 2277,             // renamed Houston Christian in 2022
  "LIU Sharks": 2341,                          // ESPN: "Long Island University Sharks"
  "Nicholls State Colonels": 2447,             // ESPN: "Nicholls Colonels"
  "Sam Houston State Bearkats": 2534,          // ESPN: "Sam Houston Bearkats"
  "Southeastern Louisiana Lions": 2545,        // ESPN: "SE Louisiana Lions"
  "Southern Mississippi Golden Eagles": 2572,  // ESPN: "Southern Miss Golden Eagles"
  "Youngstown St Penguins": 2754,              // ESPN: "Youngstown State Penguins"
  // ─────────────────────────────────────────────────────────────────────
  "Abilene Christian Wildcats": 2000,
  "Adams State Grizzlies": 2001,
  "Adrian Bulldogs": 2003,
  "Air Force Falcons": 2005,
  "Akron Zips": 2006,
  "Alabama A&M Bulldogs": 2010,
  "Alabama Crimson Tide": 333,
  "Alabama State Hornets": 2011,
  "Alabama State Lady Hornets": 2011,
  "Albany State Golden Rams": 2013,
  "Albion Britons": 2790,
  "Albright Lions": 2015,
  "Alcorn State Braves": 2016,
  "Alcorn State Lady Braves": 2016,
  "Alfred Saxons": 365,
  "Alfred State Pioneers": 3162,
  "Allegheny Gators": 2018,
  "Allen Yellow Jackets": 2019,
  "Alma Scots": 2800,
  "Alvernia Golden Wolves": 111674,
  "American International Yellow Jackets": 2022,
  "American University Eagles": 44,
  "Amherst Mammoths": 7,
  "Anderson (IN) Ravens": 2023,
  "Anderson (SC) Trojans": 129469,
  "Andrew Fighting Tigers": 134002,
  "Angelo State Rams": 2025,
  "App State Mountaineers": 2026,
  "Apprentice School Builders": 3111,
  "Arizona State Sun Devils": 9,
  "Arizona Wildcats": 12,
  "Arkansas Baptist Buffaloes": 124386,
  "Arkansas Monticello Boll Weevils": 2028,
  "Arkansas Razorbacks": 8,
  "Arkansas State Red Wolves": 2032,
  "Arkansas Tech Wonder Boys": 2033,
  "Arkansas-Pine Bluff Golden Lions": 2029,
  "Army Black Knights": 349,
  "Ashland Eagles": 308,
  "Assumption Greyhounds": 2038,
  "Auburn Tigers": 2,
  "Augsburg Auggies": 124,
  "Augustana (IL) Vikings": 2042,
  "Augustana (SD) Vikings": 2043,
  "Aurora Spartans": 2044,
  "Austin 'Roos": 2045,
  "Austin Peay Governors": 2046,
  "Ave Maria University Gyrenes": 3178,
  "Averett Cougars": 2047,
  "Avila University Eagles": 2048,
  "Azusa Pacific Cougars": 2049,
  "BLUEFIELD Ramblin' Rams": 495,
  "BYU Cougars": 252,
  "Baker University Baker": 488,
  "Baldwin Wallace Yellow Jackets": 188,
  "Ball State Cardinals": 2050,
  "Barton Bulldogs": 122666,
  "Bates Bobcats": 121,
  "Baylor Bears": 239,
  "Belhaven Blazers": 2056,
  "Bellarmine Knights": 91,
  "Belmont Bruins": 2057,
  "Beloit Buccaneers": 266,
  "Bemidji State Beavers": 132,
  "Benedict Tigers": 490,
  "Benedictine (IL) Eagles": 2283,
  "Benedictine College Ravens": 16111,
  "Bentley Falcons": 2060,
  "Berry Vikings": 2757,
  "Bethany (Ks)": 492,
  "Bethany (WV) Bison": 2062,
  "Bethel (MN) Royals": 2802,
  "Bethel University Tennessee Wildcats": 2064,
  "Bethune-Cookman Wildcats": 2065,
  "Binghamton Bearcats": 2066,
  "Black Hills State Yellow Jackets": 2069,
  "Bloomsburg Huskies": 2071,
  "Bluefield State Big Blue": 124180,
  "Bluffton Beavers": 2074,
  "Boise State Broncos": 68,
  "Boston College Eagles": 103,
  "Boston University Terriers": 104,
  "Bowdoin Polar Bears": 340,
  "Bowie State Bulldogs": 2075,
  "Bowling Green Falcons": 189,
  "Bradley Braves": 71,
  "Brevard Tornados": 2913,
  "Bridgewater Eagles": 2079,
  "Bridgewater State Bears": 18,
  "British Columbia British Col": 2080,
  "Brockport Golden Eagles": 2781,
  "Brown Bears": 225,
  "Bryant Bulldogs": 2803,
  "Bucknell Bison": 2083,
  "Buena Vista Beavers": 63,
  "Buffalo Bulls": 2084,
  "Buffalo State Bengals": 2085,
  "Butler Bulldogs": 2086,
  "CSU Pueblo ThunderWolves": 2570,
  "Cal Lutheran Kingsmen": 2094,
  "Cal Poly Mustangs": 13,
  "Cal State Bakersfield Roadrunners": 2934,
  "Cal State Fullerton Titans": 2239,
  "Cal State Northridge Matadors": 2463,
  "California (PA) Vulcans": 2858,
  "California Baptist Lancers": 2856,
  "California Golden Bears": 25,
  "Calvin Knights": 129738,
  "Campbell Fighting Camels": 2097,
  "Campbellsville University Tigers": 2098,
  "Canisius Golden Griffins": 2099,
  "Capital Comets": 424,
  "Carleton Knights": 2101,
  "Carnegie Mellon Tartans": 2102,
  "Carroll (WI) Pioneers": 32,
  "Carson Newman Eagles": 2105,
  "Carthage Firebirds": 2106,
  "Case Western Reserve Spartans": 2963,
  "Catawba Indians": 2107,
  "Catholic Cardinals": 2108,
  "Centenary (LA) Gentlemen": 101442,
  "Central Arkansas Bears": 2110,
  "Central College Dutch": 2964,
  "Central Connecticut Blue Devils": 2115,
  "Central Methodist Eagles": 2860,
  "Central Michigan Chippewas": 2117,
  "Central Missouri Mules": 2118,
  "Central Oklahoma Bronchos": 2122,
  "Central State Marauders": 2119,
  "Central Washington Wildcats": 2120,
  "Centre Colonels": 2121,
  "Chadron State Eagles": 2123,
  "Chapman Panthers": 411,
  "Charleston (WV) Golden Eagles": 2128,
  "Charleston Cougars": 232,
  "Charleston Southern Buccaneers": 2127,
  "Charlotte 49ers": 2429,
  "Charlotte Saints": 3253,
  "Chattanooga Mocs": 236,
  "Chicago Maroons": 80,
  "Chicago State Cougars": 2130,
  "Chowan Hawks": 2804,
  "Christopher Newport Captains": 3112,
  "Cincinnati Bearcats": 2132,
  "Claremont Mudd Scripps Stags": 17,
  "Clarion Golden Eagles": 2134,
  "Clark Atlanta Panthers": 2805,
  "Clemson Tigers": 228,
  "Cleveland State Vikings": 325,
  "Coast Guard Bears": 2557,
  "Coastal Carolina Chanticleers": 324,
  "Coe Kohawks": 2141,
  "Colby White Mules": 33,
  "Cole College Jaguars": 3210,
  "Colgate Raiders": 2142,
  "College of Idaho Yotes": 108382,
  "Colorado Buffaloes": 38,
  "Colorado Mesa Mavericks": 11,
  "Colorado School of Mines Orediggers": 2146,
  "Colorado State Rams": 36,
  "Columbia Lions": 171,
  "Concord Mountain Lions": 2148,
  "Concordia (MN) Cobbers": 2152,
  "Concordia (WI) Falcons": 409,
  "Concordia Chicago Cougars": 2151,
  "Concordia St. Paul Golden Bears": 3066,
  "Concordia University Nebraska Clippers": 507,
  "Concordia-Michigan Cardinals": 2985,
  "Coppin State Eagles": 2154,
  "Cornell (IA) Rams": 2155,
  "Cornell Big Red": 172,
  "Creighton Bluejays": 156,
  "Crown Polars": 509,
  "Culver-Stockton College Wildcats": 510,
  "Cumberland (TN) Bulldogs": 2161,
  "Cumberlands Indians": 511,
  "Curry Colonels": 40,
  "Dakota State University Trojans": 512,
  "Dakota Wesleyan Tigers": 513,
  "Dartmouth Big Green": 159,
  "Davidson Wildcats": 2166,
  "Dayton Flyers": 2168,
  "DePaul Blue Demons": 305,
  "DePauw Tigers": 83,
  "Dean Bulldogs": 110438,
  "Defiance College Yellow Jackets": 190,
  "Delaware Blue Hens": 48,
  "Delaware State Hornets": 2169,
  "Delaware Valley Aggies": 2808,
  "Delta State Statesmen": 2170,
  "Denison Big Red": 2171,
  "Denver Pioneers": 2172,
  "Des Moines Vikings": 2254,
  "Detroit Mercy Titans": 2174,
  "Dickinson Red Devils": 2175,
  "Dickinson State University Blue Hawks": 316,
  "Drake Bulldogs": 2181,
  "Drexel Dragons": 2182,
  "Dubuque Spartans": 49,
  "Duke Blue Devils": 150,
  "Duquesne Dukes": 2184,
  "East Carolina Pirates": 151,
  "East Central Tigers": 2191,
  "East Stroudsburg Warriors": 2188,
  "East Tennessee State Buccaneers": 2193,
  "East Tennessee State Bucs": 2193,
  "East Texas A&M Lions": 2837,
  "East Texas Baptist Tigers": 2194,
  "Eastern Eagles": 127954,
  "Eastern Illinois Panthers": 2197,
  "Eastern Kentucky Colonels": 2198,
  "Eastern Michigan Eagles": 2199,
  "Eastern New Mexico Greyhounds": 2201,
  "Eastern Oregon": 2202,
  "Eastern Washington Eagles": 331,
  "Edinboro Fighting Scots": 2205,
  "Edward Waters Tigers": 2206,
  "Elgin Eagles": 122775,
  "Elizabeth City State Vikings": 2207,
  "Elmhurst Bluejays": 72,
  "Elon Phoenix": 2210,
  "Emory & Henry Wasps": 2213,
  "Emporia State Hornets": 2214,
  "Endicott Gulls": 452,
  "Erskine Flying Fleet": 101784,
  "Eureka Red Devils": 101,
  "Evangel University Crusaders": 2865,
  "Evansville Purple Aces": 339,
  "FDU Florham Devils": 2221,
  "Fairfield Stags": 2217,
  "Fairleigh Dickinson Knights": 161,
  "Fairmont State Falcons": 2986,
  "Faulkner University Eagles": 2219,
  "Fayetteville State Broncos": 2220,
  "Ferris State Bulldogs": 2222,
  "Ferrum Panthers": 366,
  "Findlay Oilers": 2224,
  "Fitchburg State Falcons": 114,
  "Florida A&M Rattlers": 50,
  "Florida Atlantic Owls": 2226,
  "Florida Gators": 57,
  "Florida Gulf Coast Eagles": 526,
  "Florida International Panthers": 2229,
  "Florida Memorial University Lions": 125762,
  "Florida State Seminoles": 52,
  "Fordham Rams": 2230,
  "Fort Hays Tigers": 2231,
  "Fort Lewis Skyhawks": 2237,
  "Fort Valley State Wildcats": 2232,
  "Framingham State Rams": 2967,
  "Franklin & Marshall Diplomats": 2234,
  "Franklin Grizzlies": 2233,
  "Franklin Pierce Ravens": 112334,
  "Fresno State Bulldogs": 278,
  "Friends University Friends": 527,
  "Frostburg State Bobcats": 341,
  "Furman Paladins": 231,
  "Gallaudet Bison": 417,
  "Gannon Golden Knights": 367,
  "Gardner-Webb Runnin' Bulldogs": 2241,
  "Geneva Golden Tornadoes": 2242,
  "George Fox Bruins": 415,
  "George Mason Patriots": 2244,
  "George Mason University Patriots": 2244,
  "George Washington Revolutionaries": 45,
  "Georgetown College Kentucky Tigers": 2245,
  "Georgetown Hoyas": 46,
  "Georgia Bulldogs": 61,
  "Georgia Lady Bulldogs": 61,
  "Georgia Southern Eagles": 290,
  "Georgia State Panthers": 2247,
  "Georgia Tech Yellow Jackets": 59,
  "Gettysburg Bullets": 2248,
  "Glenville State Pioneers": 2249,
  "Gonzaga Bulldogs": 2250,
  "Graceland University Graceland": 530,
  "Grambling Lady Tigers": 2755,
  "Grambling Tigers": 2755,
  "Grand Canyon Lopes": 2253,
  "Grand Valley State Lakers": 125,
  "Green Bay Phoenix": 2739,
  "Greensboro Pride": 2256,
  "Greenville Panthers": 2257,
  "Grinnell Pioneers": 65,
  "Grove City Wolverines": 146,
  "Guilford Quakers": 2258,
  "Gustavus Adolphus Golden Gusties": 2968,
  "Hamilton Continentals": 348,
  "Hamline Pipers": 162,
  "Hampden Sydney Tigers": 297,
  "Hampton Lady Pirates": 2261,
  "Hampton Pirates": 2261,
  "Hanover Panthers": 2262,
  "Hardin Simmons Cowboys": 2810,
  "Harding Bisons": 2264,
  "Hartwick Hawks": 173,
  "Harvard Crimson": 108,
  "Haskell Indian Nations Univ Jayhawks": 535,
  "Hawai'i Rainbow Warriors": 62,
  "Heidelberg Student Princes": 191,
  "Henderson State Reddies": 2271,
  "Hendrix Warriors": 418,
  "High Point Panthers": 2272,
  "Hilbert Hawks": 125974,
  "Hillsdale Chargers": 2273,
  "Hiram Terriers": 2274,
  "Hobart Statesmen": 174,
  "Hofstra Pride": 2275,
  "Holland College Hurricanes": 108354,
  "Holy Cross Crusaders": 107,
  "Hope Flying Dutchmen": 2812,
  "Houston Christian Huskies": 2277,
  "Houston Cougars": 248,
  "Howard Bison": 47,
  "Howard Payne Yellow Jackets": 2758,
  "Huntingdon Hawks": 2938,
  "Husson Eagles": 2280,
  "IU Indianapolis Jaguars": 85,
  "IU Pennsylvania Crimson Hawks": 2291,
  "Idaho State Bengals": 304,
  "Idaho Vandals": 70,
  "Illinois College Blueboys": 2286,
  "Illinois Fighting Illini": 356,
  "Illinois State Redbirds": 2287,
  "Illinois Wesleyan Titans": 306,
  "Incarnate Word Cardinals": 2916,
  "Indiana Hoosiers": 84,
  "Indiana State Sycamores": 282,
  "Indiana Wesleyan Wildcats": 111756,
  "Indianapolis Greyhounds": 2292,
  "Iona Gaels": 314,
  "Iowa Hawkeyes": 2294,
  "Iowa State Cyclones": 66,
  "Ithaca Bombers": 175,
  "Jackson State Lady Tigers": 2296,
  "Jackson State Tigers": 2296,
  "Jacksonville Dolphins": 294,
  "Jacksonville State Gamecocks": 55,
  "James Madison Dukes": 256,
  "Jamestown Jimmies": 2939,
  "John Carroll Blue Streaks": 2302,
  "Johns Hopkins Blue Jays": 118,
  "Johnson C. Smith Golden Bulls": 2304,
  "Juniata Eagles": 246,
  "Kalamazoo Hornets": 126,
  "Kansas City Roos": 140,
  "Kansas Jayhawks": 2305,
  "Kansas State Wildcats": 2306,
  "Kansas Wesleyan Ks Wesleyan": 547,
  "Kean Cougars": 2871,
  "Keiser University Keiser": 126110,
  "Kennesaw State Owls": 338,
  "Kent State Golden Flashes": 2309,
  "Kentucky Christian Knights": 3077,
  "Kentucky State Thorobreds": 2310,
  "Kentucky Wesleyan Panthers": 2316,
  "Kentucky Wildcats": 96,
  "Kenyon Owls": 352,
  "Keystone Giants": 122774,
  "King's Monarchs": 247,
  "Knox Prairie Fire": 255,
  "Kutztown Golden Bears": 2315,
  "LSU New Orleans Privateers": 2443,
  "LSU Tigers": 99,
  "La Salle Explorers": 2325,
  "La Verne Leopards": 2318,
  "LaGrange Panthers": 548,
  "Lafayette Leopards": 322,
  "Lake Erie Storm": 437,
  "Lake Forest Foresters": 262,
  "Lakeland Muskies": 6353,
  "Lamar Cardinals": 2320,
  "Lane College Dragons": 2323,
  "Langston Lions": 2324,
  "Lawrence Vikings": 268,
  "Le Moyne Dolphins": 2330,
  "Lebanon Valley Flying Dutchmen": 388,
  "Lehigh Mountain Hawks": 2329,
  "Lenoir Rhyne Bears": 2331,
  "Lewis & Clark River Otters": 2333,
  "Liberty Flames": 2335,
  "Lincoln (CA) Oaklanders": 124179,
  "Lincoln (MO) Blue Tigers": 2876,
  "Lincoln (PA) Lions": 2339,
  "Lindenwood Belleville Lynx": 3209,
  "Lindenwood Lions": 2815,
  "Lindsey Wilson LINDSEY": 2877,
  "Linfield Wildcats": 203,
  "Lipscomb Bisons": 288,
  "Little Rock Trojans": 2031,
  "Livingstone Blue Bears": 2940,
  "Lock Haven Bald Eagles": 209,
  "Long Beach State Beach": 299,
  "Long Island University Sharks": 2341,
  "Longwood Lancers": 2344,
  "Loras Duhawks": 263,
  "Louisiana Christian Wildcats": 2347,
  "Louisiana Ragin' Cajuns": 309,
  "Louisiana Tech Bulldogs": 2348,
  "Louisiana Tech Lady Techsters": 2348,
  "Louisville Cardinals": 97,
  "Loyola Chicago Ramblers": 2350,
  "Loyola Maryland Greyhounds": 2352,
  "Loyola Marymount Lions": 2351,
  "Luther Norse": 67,
  "Lycoming Warriors": 2354,
  "Lyon Scots": 101161,
  "MADONNA": 126146,
  "MANITOBA": 2770,
  "MIT Engineers": 109,
  "Macalester Scots": 2359,
  "Maine Black Bears": 311,
  "Maine Maritime Mariners": 274,
  "Manchester Spartans": 2362,
  "Manhattan Jaspers": 2363,
  "Mansfield Mountaineers": 2365,
  "Marian (IN) MARIAN": 2366,
  "Marietta Pioneers": 317,
  "Marist Red Foxes": 2368,
  "Marquette Golden Eagles": 269,
  "Mars Hill Lions": 2369,
  "Marshall Thundering Herd": 276,
  "Martin Luther Knights": 446,
  "Mary Hardin Baylor Crusaders": 2371,
  "Maryland Eastern Shore Hawks": 2379,
  "Maryland Terrapins": 120,
  "Maryville (TN) Scots": 2373,
  "Mass Maritime Buccaneers": 110,
  "Massachusetts Minutemen": 113,
  "UMass Minutemen": 113,
  "UMass": 113,
  "Massachusetts Minutewomen": 113,
  "Mayville State Comets": 561,
  "McDaniel Green Terror": 2700,
  "McKendree Bearcats": 2816,
  "McMurry War Hawks": 241,
  "McNeese Cowboys": 2377,
  "McNeese Cowgirls": 2377,
  "Memphis Tigers": 235,
  "Mercer Bears": 2382,
  "Merchant Marine Mariners": 2383,
  "Mercyhurst Lakers": 2385,
  "Merrimack Warriors": 2771,
  "Methodist Monarchs": 291,
  "Miami (OH) RedHawks": 193,
  "Miami Hurricanes": 2390,
  "Michigan State Spartans": 127,
  "Michigan Tech Huskies": 2392,
  "Michigan Wolverines": 130,
  "Middle Tennessee Blue Raiders": 2393,
  "Middlebury Panthers": 2394,
  "Midland MIDLAND LUTHERAN": 565,
  "Midwestern State Mustangs": 2395,
  "Miles Golden Bears": 2396,
  "Millersville Marauders": 210,
  "Millikin Big Blue": 74,
  "Millsaps Majors": 2398,
  "Milwaukee Panthers": 270,
  "Minnesota Duluth Bulldogs": 134,
  "Minnesota Golden Gophers": 135,
  "Minnesota Morris Cougars": 2399,
  "Minnesota St Moorhead Dragons": 2817,
  "Minnesota State Mavericks": 2364,
  "Minot State Beavers": 568,
  "Misericordia Cougars": 2969,
  "Mississippi State Bulldogs": 344,
  "Mississippi Valley State Delta Devils": 2400,
  "Mississippi Valley State Devilettes": 2400,
  "Missouri Baptist Spartans": 2880,
  "Missouri S&T Miners": 2402,
  "Missouri Southern State Lions": 2403,
  "Missouri State Bears": 2623,
  "Missouri State Lady Bears": 2623,
  "Missouri Tigers": 142,
  "Missouri Western Griffons": 137,
  "Monmouth (IL) Fighting Scots": 2919,
  "Monmouth Hawks": 2405,
  "Monroe Mustangs": 134001,
  "Montana Grizzlies": 149,
  "Montana Lady Griz": 149,
  "Montana State Bobcats": 147,
  "Montana Western Bulldogs": 2701,
  "Montclair State Red Hawks": 2818,
  "Monterrey Tech Borregos": 3100,
  "Moravian Greyhounds": 323,
  "Morehead State Eagles": 2413,
  "Morehouse Maroon Tigers": 60,
  "Morgan State Bears": 2415,
  "Morgan State Lady Bears": 2415,
  "Morningside Chiefs": 2416,
  "Mount St Joseph Lions": 2419,
  "Mount St. Mary's Mountaineers": 116,
  "Mount Union Purple Raiders": 426,
  "Muhlenberg Mules": 2422,
  "Murray State Racers": 93,
  "Muskingum Fighting Muskies": 332,
  "NC State Wolfpack": 152,
  "NJIT Highlanders": 2885,
  "Navy Midshipmen": 2426,
  "Nebraska Cornhuskers": 158,
  "Nebraska Kearney Lopers": 2438,
  "Nebraska Wesleyan Prairie Wolves": 6845,
  "Nelson (TX) Lions": 2904,
  "Nevada Wolf Pack": 2440,
  "New England Nor'easters": 111675,
  "New Hampshire Wildcats": 160,
  "New Haven Chargers": 2441,
  "New Mexico Highlands Cowboys": 2424,
  "New Mexico Lobos": 167,
  "New Mexico State Aggies": 166,
  "Newberry Wolves": 2444,
  "Niagara Purple Eagles": 315,
  "Nicholls Colonels": 2447,
  "Nichols Bison": 2884,
  "Norfolk State Spartans": 2450,
  "North Alabama Lions": 2453,
  "North American Stallions": 123086,
  "North Carolina A&T Aggies": 2448,
  "North Carolina Central Eagles": 2428,
  "North Carolina Tar Heels": 153,
  "North Carolina Wesleyan Battling Bishops": 286,
  "North Central College Cardinals": 3071,
  "North Dakota Fighting Hawks": 155,
  "North Dakota State Bison": 2449,
  "North Florida Ospreys": 2454,
  "North Greenville Trailblazers": 2822,
  "North Park Vikings": 75,
  "North Texas Mean Green": 249,
  "Northeastern Huskies": 111,
  "Northeastern State RiverHawks": 196,
  "Northern Arizona Lumberjacks": 2464,
  "Northern Colorado Bears": 2458,
  "Northern Illinois Huskies": 2459,
  "Northern Iowa Panthers": 2460,
  "Northern Kentucky Norse": 94,
  "Northern Michigan Wildcats": 128,
  "Northern State Wolves": 425,
  "Northwest Missouri State Bearcats": 138,
  "Northwestern (MN) Eagles": 583,
  "Northwestern (OK) Rangers": 2823,
  "Northwestern State Demons": 2466,
  "Northwestern State Lady Demons": 2466,
  "Northwestern Wildcats": 77,
  "Northwood Timberwolves": 2886,
  "Norwich Cadets": 2467,
  "Notre Dame Fighting Irish": 87,
  "Oakland Golden Grizzlies": 2473,
  "Oberlin Yeomen": 391,
  "Ohio Bobcats": 195,
  "Ohio Northern Polar Bears": 427,
  "Ohio State Buckeyes": 194,
  "Ohio State Newark Titans": 3161,
  "Ohio Wesleyan Battling Bishops": 2980,
  "Oklahoma Baptist Bison": 319,
  "Oklahoma Panhandle OK PANHANDLE ST": 2824,
  "Oklahoma Sooners": 201,
  "Oklahoma State Cowboys": 197,
  "Oklahoma State Cowgirls": 197,
  "Old Dominion Monarchs": 295,
  "Ole Miss Rebels": 145,
  "Olivet Comets": 354,
  "Omaha Mavericks": 2437,
  "Oral Roberts Golden Eagles": 198,
  "Oregon Ducks": 2483,
  "Oregon State Beavers": 204,
  "Otterbein Cardinals": 359,
  "Ouachita Baptist Tigers": 2888,
  "Pace Setters": 2487,
  "Pacific (OR) Boxers": 205,
  "Pacific Lutheran Lutes": 2486,
  "Pacific Tigers": 279,
  "Penn State Lady Lions": 213,
  "Penn State Nittany Lions": 213,
  "Pennsylvania Quakers": 219,
  "Pepperdine Waves": 2492,
  "Phoenix Firestorm": 108358,
  "Pikeville Bears": 95,
  "Pittsburg State Gorillas": 90,
  "Pittsburgh Panthers": 221,
  "Plymouth State Panthers": 2972,
  "Point University Skyhawks": 3179,
  "Pomona Pitzer Sagehens": 2923,
  "Portland Pilots": 2501,
  "Portland State Vikings": 2502,
  "Post Eagles": 126086,
  "Prairie View A&M Lady Panthers": 2504,
  "Prairie View A&M Panthers": 2504,
  "Presbyterian Blue Hose": 2506,
  "Princeton Tigers": 163,
  "Providence Friars": 2507,
  "Puget Sound Loggers": 2508,
  "Purdue Boilermakers": 2509,
  "Purdue Fort Wayne Mastodons": 2870,
  "Queens University Royals": 2511,
  "Quincy Hawks": 2825,
  "Quinnipiac Bobcats": 2514,
  "Radford Highlanders": 2515,
  "Randolph Macon Yellow Jackets": 2516,
  "Redlands Bulldogs": 29,
  "Reinhardt Eagles": 2890,
  "Rensselaer Engineers": 2528,
  "Rhode Island Rams": 227,
  "Rhodes Lynx": 2519,
  "Rice Owls": 242,
  "Richmond Spiders": 257,
  "Rider Broncs": 2520,
  "Ripon Red Hawks": 2891,
  "Robert Morris Colonials": 2523,
  "Rochester (NY) Yellow Jackets": 184,
  "Rockford Regents": 2524,
  "Roosevelt Lakers": 599,
  "Rose Hulman Fightin' Engineers": 86,
  "Rowan Profs": 2827,
  "Rutgers Scarlet Knights": 164,
  "SE Louisiana Lady Lions": 2545,
  "SE Louisiana Lions": 2545,
  "SIU Edwardsville Cougars": 2565,
  "SMU Mustangs": 2567,
  "SUNY Cortland Red Dragons": 2782,
  "SUNY Erie Kats": 3236,
  "SUNY Maritime Privateers": 2951,
  "SUNY Morrisville Mustangs": 3110,
  "Sacramento State Hornets": 16,
  "Sacred Heart Pioneers": 2529,
  "Saginaw Valley State Cardinals": 129,
  "Saint Anselm Hawks": 2830,
  "Saint Francis (IN) Cougars": 2831,
  "Saint Francis Red Flash": 2598,
  "Saint John's (MN) Johnnies": 2600,
  "Saint Joseph's Hawks": 2603,
  "Saint Louis Billikens": 139,
  "Saint Mary's Gaels": 2608,
  "Saint Peter's Peacocks": 2612,
  "Saint Vincent Bearcats": 2614,
  "Saint Xavier Cougars": 2615,
  "Salisbury Sea Gulls": 2532,
  "Salve Regina Seahawks": 2776,
  "Sam Houston Bearkats": 2534,
  "Samford Bulldogs": 2535,
  "San Diego State Aztecs": 21,
  "San Diego Toreros": 301,
  "San Francisco Dons": 2539,
  "San José State Spartans": 23,
  "Santa Clara Broncos": 2541,
  "Savannah State Tigers": 2542,
  "Seattle U Redhawks": 2547,
  "Seton Hall Pirates": 2550,
  "Seton Hill Griffins": 611,
  "Sewanee Tigers": 2553,
  "Shaw Bears": 2551,
  "Shenandoah Hornets": 2828,
  "Shepherd Rams": 2974,
  "Shippensburg Raiders": 2559,
  "Shorter Hawks": 2560,
  "Siena Heights Saints": 2562,
  "Siena Saints": 2561,
  "Simpson (CA) Red Hawks": 129758,
  "Simpson (IA) Storm": 2564,
  "Sioux Falls Cougars": 2894,
  "Slippery Rock The Rock": 215,
  "South Alabama Jaguars": 6,
  "South Carolina Gamecocks": 2579,
  "South Carolina State Bulldogs": 2569,
  "South Carolina State Lady Bulldogs": 2569,
  "South Carolina Upstate Spartans": 2908,
  "South Dakota Coyotes": 233,
  "South Dakota Mines Hardrockers": 613,
  "South Dakota State Jackrabbits": 2571,
  "South Florida Bulls": 58,
  "Southeast Missouri State Redhawks": 2546,
  "Southeastern Fires": 267,
  "Southeastern Oklahoma State Savage Storm": 199,
  "Southern Arkansas Muleriders": 2568,
  "Southern Connecticut State Owls": 2583,
  "Southern Illinois Salukis": 79,
  "Southern Indiana Screaming Eagles": 88,
  "Southern Jaguars": 2582,
  "Southern Miss Golden Eagles": 2572,
  "Southern Miss Lady Eagles": 2572,
  "Southern Nazarene Crimson Storm": 200,
  "Southern Oregon Raiders": 2584,
  "Southern Utah Thunderbirds": 253,
  "Southern Virginia Knights": 2896,
  "Southwest Baptist Bearcats": 2586,
  "Southwest Minnesota State Mustangs": 2587,
  "Southwestern (KS) Moundbuilders": 616,
  "Southwestern Oklahoma State Bulldogs": 2927,
  "Southwestern U Pirates": 2588,
  "Springfield Pride": 81,
  "St. Ambrose Fighting Bees": 2591,
  "St. Andrews Knights": 111610,
  "St. Bonaventure Bonnies": 179,
  "St. Francis (IL) Fighting Saints": 2595,
  "St. John Fisher Cardinals": 374,
  "St. John's Red Storm": 2599,
  "St. Lawrence Saints": 2779,
  "St. Norbert Green Knights": 2832,
  "St. Olaf Oles": 133,
  "St. Petersburg Glory Eagles": 3254,
  "St. Scholastica Saints": 375,
  "St. Thomas Tommies": 2900,
  "Stanford Cardinal": 24,
  "Stephen F. Austin Ladyjacks": 2617,
  "Stephen F. Austin Lumberjacks": 2617,
  "Sterling STERLING KS": 618,
  "Stetson Hatters": 56,
  "Stevenson Mustangs": 471,
  "Stonehill Skyhawks": 284,
  "Stony Brook Seawolves": 2619,
  "Sul Ross State Lobos": 2834,
  "Susquehanna River Hawks": 216,
  "Syracuse Orange": 183,
  "TCU Horned Frogs": 2628,
  "Tarleton State Texans": 2627,
  "Taylor Trojans": 620,
  "Temple Owls": 218,
  "Tennessee Lady Volunteers": 2633,
  "Tennessee State Lady Tigers": 2634,
  "Tennessee State Tigers": 2634,
  "Tennessee Tech Golden Eagles": 2635,
  "Tennessee Volunteers": 2633,
  "Texas A&M Aggies": 245,
  "Texas A&M-Corpus Christi Islanders": 357,
  "Texas A&M-Kingsville Javelinas": 2658,
  "Texas College Steers": 2637,
  "Texas Longhorns": 251,
  "Texas Lutheran Bulldogs": 2639,
  "Texas Southern Tigers": 2640,
  "Texas State Bobcats": 326,
  "Texas Tech Lady Raiders": 2641,
  "Texas Tech Red Raiders": 2641,
  "The Citadel Bulldogs": 2643,
  "The College of New Jersey Lions": 2442,
  "Thiel Tomcats": 2644,
  "Thomas More Saints": 2646,
  "Thomas Night Hawks": 134000,
  "Tiffin Dragons": 2838,
  "Toledo Rockets": 2649,
  "Towson Tigers": 119,
  "Trine Thunder": 2651,
  "Trinity (CT) Bantams": 2977,
  "Trinity (TX) Tigers": 386,
  "Trinity Bible Lions": 3214,
  "Troy Trojans": 2653,
  "Troy Vikings": 3237,
  "Truman State Bulldogs": 2654,
  "Tufts Jumbos": 112,
  "Tulane Green Wave": 2655,
  "Tulsa Golden Hurricane": 202,
  "Tusculum Pioneers": 2839,
  "Tuskegee Golden Tigers": 2657,
  "UAB Blazers": 5,
  "UAlbany Great Danes": 399,
  "UC Davis Aggies": 302,
  "UC Irvine Anteaters": 300,
  "UC Riverside Highlanders": 27,
  "UC San Diego Tritons": 28,
  "UC Santa Barbara Gauchos": 2540,
  "UCF Knights": 2116,
  "UCLA Bruins": 26,
  "UConn Huskies": 41,
  "UIC Flames": 82,
  "UL Monroe Warhawks": 2433,
  "UMBC Retrievers": 2378,
  "UMass Dartmouth Corsairs": 379,
  "UMass Lowell River Hawks": 2349,
  "UNC Asheville Bulldogs": 2427,
  "UNC Greensboro Spartans": 2430,
  "UNC Pembroke Braves": 2882,
  "UNC Wilmington Seahawks": 350,
  "UNLV Lady Rebels": 2439,
  "UNLV Rebels": 2439,
  "USC Trojans": 30,
  "UT Arlington Mavericks": 250,
  "UT Martin Skyhawks": 2630,
  "UT Permian Basin Falcons": 110243,
  "UT Rio Grande Valley Vaqueros": 292,
  "UTEP Miners": 2638,
  "UTSA Roadrunners": 2636,
  "UVA Wise Cavaliers": 2842,
  "Union Garnet Chargers": 237,
  "University of Mary Marauders": 559,
  "University of Mexico MEXICO U": 3212,
  "Upper Iowa Peacocks": 389,
  "Ursinus Bears": 2667,
  "Utah State Aggies": 328,
  "Utah Tech Trailblazers": 3101,
  "Utah Utes": 254,
  "Utah Valley Wolverines": 3084,
  "Utica Pioneers": 390,
  "VCU Rams": 2670,
  "VMI Keydets": 2678,
  "Valdosta State Blazers": 2673,
  "Valley City State VALLEY CITY ST": 628,
  "Valparaiso Beacons": 2674,
  "Vanderbilt Commodores": 238,
  "Vermont Catamounts": 261,
  "Vermont State Castleton Spartans": 293,
  "Villanova Wildcats": 222,
  "Virginia Cavaliers": 258,
  "Virginia Lynchburg Dragons": 2355,
  "Virginia State Trojans": 330,
  "Virginia Tech Hokies": 259,
  "Virginia Union Panthers": 2676,
  "WPI Engineers": 2749,
  "WVU Tech Golden Bears": 2706,
  "Wabash Little Giants": 89,
  "Wagner Seahawks": 2681,
  "Wake Forest Demon Deacons": 154,
  "Waldorf Warriors": 3080,
  "Walsh Cavaliers": 2682,
  "Warner Royals": 2683,
  "Wartburg Knights": 2685,
  "Washburn Ichabods": 2687,
  "Washington & Jefferson Presidents": 2686,
  "Washington Huskies": 264,
  "Washington St. Louis Bears": 143,
  "Washington State Cougars": 265,
  "Washington and Lee Generals": 2688,
  "Wayland Baptist Pioneers": 630,
  "Wayne State (MI) Warriors": 131,
  "Wayne State (NE) Wildcats": 2844,
  "Waynesburg Yellow Jackets": 2845,
  "Webber International Warriors": 2691,
  "Weber State Wildcats": 2692,
  "Wesleyan (CT) Cardinals": 336,
  "West Alabama Tigers": 2695,
  "West Chester Golden Rams": 223,
  "West Florida Argonauts": 110242,
  "West Georgia Wolves": 2698,
  "West Liberty Hilltoppers": 2699,
  "West Memphis Crusaders": 3211,
  "West Texas Buffaloes": 2704,
  "West Virginia Mountaineers": 277,
  "West Virginia State Yellow Jackets": 2707,
  "West Virginia Wesleyan Bobcats": 455,
  "Western Carolina Catamounts": 2717,
  "Western Colorado Mountaineers": 2714,
  "Western Connecticut State Wolves": 2843,
  "Western Illinois Leathernecks": 2710,
  "Western Kentucky Hilltoppers": 98,
  "Western Kentucky Lady Toppers": 98,
  "Western Michigan Broncos": 2711,
  "Western New England Golden Bears": 2702,
  "Western New Mexico Mustangs": 2703,
  "Western Oregon Wolves": 2848,
  "Westfield State Owls": 2909,
  "Westgate Christian University Ravens": 134087,
  "Westminster (MO) Blue Jays": 433,
  "Westminster (PA) Titans": 2849,
  "Wheaton (IL) Thunder": 396,
  "Wheeling Cardinals": 112335,
  "Whittier Poets": 2850,
  "Whitworth Pirates": 2721,
  "Wichita State Shockers": 2724,
  "Widener Pride": 2725,
  "Wilkes Colonels": 398,
  "Willamette Bearcats": 2930,
  "William & Mary Tribe": 2729,
  "William Jewell Cardinals": 2911,
  "William Paterson Pioneers": 2970,
  "William Penn Statesmen": 2912,
  "Williams Ephs": 2731,
  "Williamson Mechanics": 3130,
  "Wilmington (OH) Fightin' Quakers": 2733,
  "Wingate Bulldogs": 351,
  "Winona State Warriors": 2851,
  "Winston-Salem State Rams": 2736,
  "Winthrop Eagles": 2737,
  "Wisconsin Badgers": 275,
  "Wisconsin Eau Claire Blugolds": 2738,
  "Wisconsin La Crosse Eagles": 2740,
  "Wisconsin Lutheran Warriors": 2741,
  "Wisconsin Oshkosh Titans": 271,
  "Wisconsin Platteville Pioneers": 272,
  "Wisconsin River Falls Falcons": 2723,
  "Wisconsin Stevens Point Pointers": 2743,
  "Wisconsin Stout Blue Devils": 2744,
  "Wisconsin Whitewater Warhawks": 2745,
  "Wittenberg Tigers": 2746,
  "Wofford Terriers": 2747,
  "Wooster Fighting Scots": 2748,
  "Worcester State Lancers": 402,
  "Wright State Raiders": 2750,
  "Wyoming Cowboys": 2751,
  "Wyoming Cowgirls": 2751,
  "Xavier Musketeers": 2752,
  "Yale Bulldogs": 43,
  "Youngstown State Penguins": 2754,
}

// ESPN's own abbreviation for every college team we carry an id for.
//
// Without this, getTeamAbbr fell through to a heuristic in the prop cards:
// two-word names took the first three letters and longer ones took initials.
// That produced FLO for Florida (ESPN says FLA) and ACT for Alabama Crimson
// Tide (ALA) — close enough to look like a bug rather than a shorthand.
//
// Generated by joining ESPN's /teams abbreviation onto the ids already in
// NCAA_IDS above, so the two maps cannot disagree about which school is
// which. 897 of 0 resolved; the rest keep the heuristic.
//
// Football ids first, then men's basketball for schools with no FBS team —
// ESPN uses one id per school across sports, so the abbreviation is shared.
const NCAA_ABBRS = {
  "Albany": 'UALB', "Appalachian State Mountaineers": 'APP', "Citadel Bulldogs": 'CIT',
  "Houston Baptist Huskies": 'HCU', "LIU Sharks": 'LIU', "Nicholls State Colonels": 'NICH',
  "Sam Houston State Bearkats": 'SHSU', "Southeastern Louisiana Lions": 'SELA', "Southern Mississippi Golden Eagles": 'USM',
  "Youngstown St Penguins": 'YSU', "Abilene Christian Wildcats": 'ACU', "Adams State Grizzlies": 'ADSU',
  "Adrian Bulldogs": 'ADR', "Air Force Falcons": 'AF', "Akron Zips": 'AKR',
  "Alabama A&M Bulldogs": 'AAMU', "Alabama Crimson Tide": 'ALA', "Alabama State Hornets": 'ALST',
  "Alabama State Lady Hornets": 'ALST', "Albany State Golden Rams": 'ABSU', "Albion Britons": 'ALBI',
  "Albright Lions": 'ALBR', "Alcorn State Braves": 'ALCN', "Alcorn State Lady Braves": 'ALCN',
  "Alfred Saxons": 'ALFR', "Alfred State Pioneers": 'AFST', "Allegheny Gators": 'ALLG',
  "Allen Yellow Jackets": 'ALNU', "Alma Scots": 'ALMA', "Alvernia Golden Wolves": 'ALVR',
  "American International Yellow Jackets": 'AIC', "American University Eagles": 'AMER', "Amherst Mammoths": 'AMH',
  "Anderson (IN) Ravens": 'ANIN', "Anderson (SC) Trojans": 'ANSC', "Andrew Fighting Tigers": 'AND',
  "Angelo State Rams": 'AGSU', "App State Mountaineers": 'APP', "Apprentice School Builders": 'APPRE',
  "Arizona State Sun Devils": 'ASU', "Arizona Wildcats": 'ARIZ', "Arkansas Baptist Buffaloes": 'ARBA',
  "Arkansas Monticello Boll Weevils": 'UAM', "Arkansas Razorbacks": 'ARK', "Arkansas State Red Wolves": 'ARST',
  "Arkansas Tech Wonder Boys": 'ARTE', "Arkansas-Pine Bluff Golden Lions": 'UAPB', "Army Black Knights": 'ARMY',
  "Ashland Eagles": 'ASH', "Assumption Greyhounds": 'ASP', "Auburn Tigers": 'AUB',
  "Augsburg Auggies": 'AUGS', "Augustana (IL) Vikings": 'AUGC', "Augustana (SD) Vikings": 'AUSD',
  "Aurora Spartans": 'AUR', "Austin 'Roos": 'AUS', "Austin Peay Governors": 'APSU',
  "Ave Maria University Gyrenes": 'AVE M', "Averett Cougars": 'AVER', "Avila University Eagles": 'AVILA',
  "Azusa Pacific Cougars": 'APU', "BLUEFIELD Ramblin' Rams": 'BLU', "BYU Cougars": 'BYU',
  "Baker University Baker": 'BAK', "Baldwin Wallace Yellow Jackets": 'BW', "Ball State Cardinals": 'BALL',
  "Barton Bulldogs": 'BART', "Bates Bobcats": 'BATE', "Baylor Bears": 'BAY',
  "Belhaven Blazers": 'BELH', "Bellarmine Knights": 'BELL', "Belmont Bruins": 'BEL',
  "Beloit Buccaneers": 'BELO', "Bemidji State Beavers": 'BST', "Benedict Tigers": 'BEN',
  "Benedictine (IL) Eagles": 'BNIL', "Benedictine College Ravens": 'BENC', "Bentley Falcons": 'BENT',
  "Berry Vikings": 'BERR', "Bethany (Ks)": 'BYKS', "Bethany (WV) Bison": 'BCWV',
  "Bethel (MN) Royals": 'BUMN', "Bethel University Tennessee Wildcats": 'BTTN', "Bethune-Cookman Wildcats": 'BCU',
  "Binghamton Bearcats": 'BING', "Black Hills State Yellow Jackets": 'BHSU', "Bloomsburg Huskies": 'BBU',
  "Bluefield State Big Blue": 'BLUS', "Bluffton Beavers": 'BLF', "Boise State Broncos": 'BOIS',
  "Boston College Eagles": 'BC', "Boston University Terriers": 'BU', "Bowdoin Polar Bears": 'BOW',
  "Bowie State Bulldogs": 'BOWE', "Bowling Green Falcons": 'BGSU', "Bradley Braves": 'BRAD',
  "Brevard Tornados": 'BRE', "Bridgewater Eagles": 'BRI', "Bridgewater State Bears": 'BRIS',
  "British Columbia British Col": 'BBM', "Brockport Golden Eagles": 'BRO', "Brown Bears": 'BRWN',
  "Bryant Bulldogs": 'BRY', "Bucknell Bison": 'BUCK', "Buena Vista Beavers": 'BVU',
  "Buffalo Bulls": 'BUF', "Buffalo State Bengals": 'BSU', "Butler Bulldogs": 'BTLR',
  "CSU Pueblo ThunderWolves": 'CSUP', "Cal Lutheran Kingsmen": 'CLU', "Cal Poly Mustangs": 'CP',
  "Cal State Bakersfield Roadrunners": 'CSUB', "Cal State Fullerton Titans": 'CSUF', "Cal State Northridge Matadors": 'CSUN',
  "California (PA) Vulcans": 'CAPA', "California Baptist Lancers": 'CBU', "California Golden Bears": 'CAL',
  "Calvin Knights": 'CALU', "Campbell Fighting Camels": 'CAM', "Campbellsville University Tigers": 'CBVU',
  "Canisius Golden Griffins": 'CAN', "Capital Comets": 'CAPU', "Carleton Knights": 'CAR',
  "Carnegie Mellon Tartans": 'CGMU', "Carroll (WI) Pioneers": 'CRU', "Carson Newman Eagles": 'CN',
  "Carthage Firebirds": 'CCW', "Case Western Reserve Spartans": 'CWRU', "Catawba Indians": 'CAT',
  "Catholic Cardinals": 'CATH', "Centenary (LA) Gentlemen": 'CTLA', "Central Arkansas Bears": 'CARK',
  "Central College Dutch": 'CNTC', "Central Connecticut Blue Devils": 'CCSU', "Central Methodist Eagles": 'CDF',
  "Central Michigan Chippewas": 'CMU', "Central Missouri Mules": 'UCM', "Central Oklahoma Bronchos": 'UCO',
  "Central State Marauders": 'CNSU', "Central Washington Wildcats": 'CWAU', "Centre Colonels": 'CCO',
  "Chadron State Eagles": 'CHAD', "Chapman Panthers": 'CHAP', "Charleston (WV) Golden Eagles": 'UCWV',
  "Charleston Cougars": 'COFC', "Charleston Southern Buccaneers": 'CHSO', "Charlotte 49ers": 'CLT',
  "Charlotte Saints": 'COLLE', "Chattanooga Mocs": 'UTC', "Chicago Maroons": 'CHI',
  "Chicago State Cougars": 'CHST', "Chowan Hawks": 'CWAN', "Christopher Newport Captains": 'CNU',
  "Cincinnati Bearcats": 'CIN', "Claremont Mudd Scripps Stags": 'CMS', "Clarion Golden Eagles": 'CLRN',
  "Clark Atlanta Panthers": 'CKGA', "Clemson Tigers": 'CLEM', "Cleveland State Vikings": 'CLE',
  "Coast Guard Bears": 'USCG', "Coastal Carolina Chanticleers": 'CCU', "Coe Kohawks": 'COE',
  "Colby White Mules": 'CLBY', "Cole College Jaguars": 'COLE', "Colgate Raiders": 'COLG',
  "College of Idaho Yotes": 'COI', "Colorado Buffaloes": 'COLO', "Colorado Mesa Mavericks": 'COMU',
  "Colorado School of Mines Orediggers": 'CMIN', "Colorado State Rams": 'CSU', "Columbia Lions": 'COLU',
  "Concord Mountain Lions": 'CONC', "Concordia (MN) Cobbers": 'CCMN', "Concordia (WI) Falcons": 'CUW',
  "Concordia Chicago Cougars": 'CUC', "Concordia St. Paul Golden Bears": 'CSP', "Concordia University Nebraska Clippers": 'CONCONE',
  "Concordia-Michigan Cardinals": 'CONCMI', "Coppin State Eagles": 'COPP', "Cornell (IA) Rams": 'CNIA',
  "Cornell Big Red": 'COR', "Creighton Bluejays": 'CREI', "Crown Polars": 'CRWN',
  "Culver-Stockton College Wildcats": 'CULVE', "Cumberland (TN) Bulldogs": 'CUMBTN', "Cumberlands Indians": 'CMBS',
  "Curry Colonels": 'CC', "Dakota State University Trojans": 'DAKOT', "Dakota Wesleyan Tigers": 'DWU',
  "Dartmouth Big Green": 'DART', "Davidson Wildcats": 'DAV', "Dayton Flyers": 'DAY',
  "DePaul Blue Demons": 'DEP', "DePauw Tigers": 'DPU', "Dean Bulldogs": 'DEAN',
  "Defiance College Yellow Jackets": 'DEF', "Delaware Blue Hens": 'DEL', "Delaware State Hornets": 'DSU',
  "Delaware Valley Aggies": 'DVU', "Delta State Statesmen": 'DLST', "Denison Big Red": 'DSN',
  "Denver Pioneers": 'DEN', "Des Moines Vikings": 'GRANDVIEW', "Detroit Mercy Titans": 'DETM',
  "Dickinson Red Devils": 'DKSN', "Dickinson State University Blue Hawks": 'DIC', "Drake Bulldogs": 'DRKE',
  "Drexel Dragons": 'DREX', "Dubuque Spartans": 'DBQ', "Duke Blue Devils": 'DUKE',
  "Duquesne Dukes": 'DUQ', "East Carolina Pirates": 'ECU', "East Central Tigers": 'ECNU',
  "East Stroudsburg Warriors": 'ESU', "East Tennessee State Buccaneers": 'ETSU', "East Tennessee State Bucs": 'ETSU',
  "East Texas A&M Lions": 'ETAM', "East Texas Baptist Tigers": 'ETBU', "Eastern Eagles": 'EU',
  "Eastern Illinois Panthers": 'EIU', "Eastern Kentucky Colonels": 'EKU', "Eastern Michigan Eagles": 'EMU',
  "Eastern New Mexico Greyhounds": 'ENMU', "Eastern Oregon": 'EORE', "Eastern Washington Eagles": 'EWU',
  "Edinboro Fighting Scots": 'EDBR', "Edward Waters Tigers": 'EDW', "Elgin Eagles": 'JUDSO',
  "Elizabeth City State Vikings": 'ECSU', "Elmhurst Bluejays": 'ELMH', "Elon Phoenix": 'ELON',
  "Emory & Henry Wasps": 'EHC', "Emporia State Hornets": 'EMSU', "Endicott Gulls": 'ENDC',
  "Erskine Flying Fleet": 'ERSK', "Eureka Red Devils": 'ERKA', "Evangel University Crusaders": 'EVA',
  "Evansville Purple Aces": 'EVAN', "FDU Florham Devils": 'FDUF', "Fairfield Stags": 'FAIR',
  "Fairleigh Dickinson Knights": 'FDU', "Fairmont State Falcons": 'FMSU', "Faulkner University Eagles": 'FAULKNER',
  "Fayetteville State Broncos": 'FAYU', "Ferris State Bulldogs": 'FRST', "Ferrum Panthers": 'FC',
  "Findlay Oilers": 'UF', "Fitchburg State Falcons": 'FBSU', "Florida A&M Rattlers": 'FAMU',
  "Florida Atlantic Owls": 'FAU', "Florida Gators": 'FLA', "Florida Gulf Coast Eagles": 'FGCU',
  "Florida International Panthers": 'FIU', "Florida Memorial University Lions": 'FMU', "Florida State Seminoles": 'FSU',
  "Fordham Rams": 'FOR', "Fort Hays Tigers": 'FHSU', "Fort Lewis Skyhawks": 'FLWC',
  "Fort Valley State Wildcats": 'FVSU', "Framingham State Rams": 'FRSU', "Franklin & Marshall Diplomats": 'FMC',
  "Franklin Grizzlies": 'FRKL', "Franklin Pierce Ravens": 'FP', "Fresno State Bulldogs": 'FRES',
  "Friends University Friends": 'FRIE', "Frostburg State Bobcats": 'FSTU', "Furman Paladins": 'FUR',
  "Gallaudet Bison": 'GLDT', "Gannon Golden Knights": 'GANN', "Gardner-Webb Runnin' Bulldogs": 'GWEB',
  "Geneva Golden Tornadoes": 'GEN', "George Fox Bruins": 'GFU', "George Mason Patriots": 'GMU',
  "George Mason University Patriots": 'GMU', "George Washington Revolutionaries": 'GW', "Georgetown College Kentucky Tigers": 'GTKY',
  "Georgetown Hoyas": 'GTWN', "Georgia Bulldogs": 'UGA', "Georgia Lady Bulldogs": 'UGA',
  "Georgia Southern Eagles": 'GASO', "Georgia State Panthers": 'GAST', "Georgia Tech Yellow Jackets": 'GT',
  "Gettysburg Bullets": 'GTYB', "Glenville State Pioneers": 'GVLS', "Gonzaga Bulldogs": 'GONZ',
  "Graceland University Graceland": 'GRC', "Grambling Lady Tigers": 'GRAM', "Grambling Tigers": 'GRAM',
  "Grand Canyon Lopes": 'GCU', "Grand Valley State Lakers": 'GVSU', "Green Bay Phoenix": 'GB',
  "Greensboro Pride": 'GRNB', "Greenville Panthers": 'GRNV', "Grinnell Pioneers": 'GRNL',
  "Grove City Wolverines": 'GRO', "Guilford Quakers": 'GLFD', "Gustavus Adolphus Golden Gusties": 'GAC',
  "Hamilton Continentals": 'HAM', "Hamline Pipers": 'HMLN', "Hampden Sydney Tigers": 'HSC',
  "Hampton Lady Pirates": 'HAMP', "Hampton Pirates": 'HAMP', "Hanover Panthers": 'HNVR',
  "Hardin Simmons Cowboys": 'HSU', "Harding Bisons": 'HARD', "Hartwick Hawks": 'HRTW',
  "Harvard Crimson": 'HARV', "Haskell Indian Nations Univ Jayhawks": 'HASKELL', "Hawai'i Rainbow Warriors": 'HAW',
  "Heidelberg Student Princes": 'HDBG', "Henderson State Reddies": 'HSTU', "Hendrix Warriors": 'HDX',
  "High Point Panthers": 'HPU', "Hilbert Hawks": 'HLBT', "Hillsdale Chargers": 'HLDL',
  "Hiram Terriers": 'HIRM', "Hobart Statesmen": 'HBRT', "Hofstra Pride": 'HOF',
  "Holland College Hurricanes": 'HOL', "Holy Cross Crusaders": 'HC', "Hope Flying Dutchmen": 'HOPE',
  "Houston Christian Huskies": 'HCU', "Houston Cougars": 'HOU', "Howard Bison": 'HOW',
  "Howard Payne Yellow Jackets": 'HWPU', "Huntingdon Hawks": 'HNTC', "Husson Eagles": 'HUSS',
  "IU Indianapolis Jaguars": 'IUIN', "IU Pennsylvania Crimson Hawks": 'IUP', "Idaho State Bengals": 'IDST',
  "Idaho Vandals": 'IDHO', "Illinois College Blueboys": 'ILLC', "Illinois Fighting Illini": 'ILL',
  "Illinois State Redbirds": 'ILST', "Illinois Wesleyan Titans": 'ILWU', "Incarnate Word Cardinals": 'UIW',
  "Indiana Hoosiers": 'IU', "Indiana State Sycamores": 'INST', "Indiana Wesleyan Wildcats": 'INWESL',
  "Indianapolis Greyhounds": 'INDY', "Iona Gaels": 'IONA', "Iowa Hawkeyes": 'IOWA',
  "Iowa State Cyclones": 'ISU', "Ithaca Bombers": 'ITH', "Jackson State Lady Tigers": 'JKST',
  "Jackson State Tigers": 'JKST', "Jacksonville Dolphins": 'JAX', "Jacksonville State Gamecocks": 'JXST',
  "James Madison Dukes": 'JMU', "Jamestown Jimmies": 'UJ', "John Carroll Blue Streaks": 'JCU',
  "Johns Hopkins Blue Jays": 'JHU', "Johnson C. Smith Golden Bulls": 'JCSU', "Juniata Eagles": 'JUN',
  "Kalamazoo Hornets": 'KALC', "Kansas City Roos": 'KC', "Kansas Jayhawks": 'KU',
  "Kansas State Wildcats": 'KSU', "Kansas Wesleyan Ks Wesleyan": 'KANSA', "Kean Cougars": 'KEAN',
  "Keiser University Keiser": 'KEISER', "Kennesaw State Owls": 'KENN', "Kent State Golden Flashes": 'KENT',
  "Kentucky Christian Knights": 'KYCHR', "Kentucky State Thorobreds": 'KYSU', "Kentucky Wesleyan Panthers": 'KWC',
  "Kentucky Wildcats": 'UK', "Kenyon Owls": 'KNY', "Keystone Giants": 'KYSN',
  "King's Monarchs": 'KNGS', "Knox Prairie Fire": 'KNOX', "Kutztown Golden Bears": 'KUTZ',
  "LSU New Orleans Privateers": 'NOLA', "LSU Tigers": 'LSU', "La Salle Explorers": 'LAS',
  "La Verne Leopards": 'ULV', "LaGrange Panthers": 'LGC', "Lafayette Leopards": 'LAF',
  "Lake Erie Storm": 'LKER', "Lake Forest Foresters": 'LFC', "Lakeland Muskies": 'LKLD',
  "Lamar Cardinals": 'LAM', "Lane College Dragons": 'LANE', "Langston Lions": 'LNGT',
  "Lawrence Vikings": 'LAW', "Le Moyne Dolphins": 'LEM', "Lebanon Valley Flying Dutchmen": 'LVC',
  "Lehigh Mountain Hawks": 'LEH', "Lenoir Rhyne Bears": 'LENR', "Lewis & Clark River Otters": 'LC',
  "Liberty Flames": 'LIB', "Lincoln (CA) Oaklanders": 'LNCA', "Lincoln (MO) Blue Tigers": 'LNMO',
  "Lincoln (PA) Lions": 'LNPA', "Lindenwood Belleville Lynx": 'LINB', "Lindenwood Lions": 'LIN',
  "Lindsey Wilson LINDSEY": 'LWU', "Linfield Wildcats": 'LINF', "Lipscomb Bisons": 'LIP',
  "Little Rock Trojans": 'LR', "Livingstone Blue Bears": 'LIV', "Lock Haven Bald Eagles": 'LHU',
  "Long Beach State Beach": 'LBSU', "Long Island University Sharks": 'LIU', "Longwood Lancers": 'LONG',
  "Loras Duhawks": 'LOR', "Louisiana Christian Wildcats": 'LCHR', "Louisiana Ragin' Cajuns": 'UL',
  "Louisiana Tech Bulldogs": 'LT', "Louisiana Tech Lady Techsters": 'LT', "Louisville Cardinals": 'LOU',
  "Loyola Chicago Ramblers": 'LUC', "Loyola Maryland Greyhounds": 'L-MD', "Loyola Marymount Lions": 'LMU',
  "Luther Norse": 'LUTH', "Lycoming Warriors": 'LYCO', "Lyon Scots": 'LYON',
  "MADONNA": 'MDNN', "MANITOBA": 'MB', "MIT Engineers": 'MIT',
  "Macalester Scots": 'MAC', "Maine Black Bears": 'ME', "Maine Maritime Mariners": 'UMMA',
  "Manchester Spartans": 'MNCH', "Manhattan Jaspers": 'MAN', "Mansfield Mountaineers": 'MNFD',
  "Marian (IN) MARIAN": 'MUIN', "Marietta Pioneers": 'MRTT', "Marist Red Foxes": 'MRST',
  "Marquette Golden Eagles": 'MARQ', "Mars Hill Lions": 'MHU', "Marshall Thundering Herd": 'MRSH',
  "Martin Luther Knights": 'MLC', "Mary Hardin Baylor Crusaders": 'MHB', "Maryland Eastern Shore Hawks": 'UMES',
  "Maryland Terrapins": 'MD', "Maryville (TN) Scots": 'MCTN', "Mass Maritime Buccaneers": 'MMT',
  "Massachusetts Minutemen": 'MASS', "UMass Minutemen": 'MASS', "UMass": 'MASS',
  "Massachusetts Minutewomen": 'MASS', "Mayville State Comets": 'MYSU', "McDaniel Green Terror": 'MCD',
  "McKendree Bearcats": 'MCK', "McMurry War Hawks": 'MCM', "McNeese Cowboys": 'MCN',
  "McNeese Cowgirls": 'MCN', "Memphis Tigers": 'MEM', "Mercer Bears": 'MER',
  "Merchant Marine Mariners": 'MMA', "Mercyhurst Lakers": 'MERC', "Merrimack Warriors": 'MRMK',
  "Methodist Monarchs": 'MU', "Miami (OH) RedHawks": 'M-OH', "Miami Hurricanes": 'MIA',
  "Michigan State Spartans": 'MSU', "Michigan Tech Huskies": 'MTU', "Michigan Wolverines": 'MICH',
  "Middle Tennessee Blue Raiders": 'MTSU', "Middlebury Panthers": 'MIDB', "Midland MIDLAND LUTHERAN": 'MIDL',
  "Midwestern State Mustangs": 'MWSU', "Miles Golden Bears": 'MILE', "Millersville Marauders": 'MILL',
  "Millikin Big Blue": 'MILK', "Millsaps Majors": 'MLSP', "Milwaukee Panthers": 'MILW',
  "Minnesota Duluth Bulldogs": 'UMD', "Minnesota Golden Gophers": 'MINN', "Minnesota Morris Cougars": 'MNMO',
  "Minnesota St Moorhead Dragons": 'MSUM', "Minnesota State Mavericks": 'MNST', "Minot State Beavers": 'MINS',
  "Misericordia Cougars": 'MISE', "Mississippi State Bulldogs": 'MSST', "Mississippi Valley State Delta Devils": 'MVSU',
  "Mississippi Valley State Devilettes": 'MVSU', "Missouri Baptist Spartans": 'MOBU', "Missouri S&T Miners": 'MS&T',
  "Missouri Southern State Lions": 'MSSU', "Missouri State Bears": 'MOST', "Missouri State Lady Bears": 'MOST',
  "Missouri Tigers": 'MIZ', "Missouri Western Griffons": 'MOWE', "Monmouth (IL) Fighting Scots": 'MNIL',
  "Monmouth Hawks": 'MONM', "Monroe Mustangs": 'MON', "Montana Grizzlies": 'MONT',
  "Montana Lady Griz": 'MONT', "Montana State Bobcats": 'MTST', "Montana Western Bulldogs": 'UMW',
  "Montclair State Red Hawks": 'MCST', "Monterrey Tech Borregos": 'MITE', "Moravian Greyhounds": 'MOR',
  "Morehead State Eagles": 'MORE', "Morehouse Maroon Tigers": 'MRHO', "Morgan State Bears": 'MORG',
  "Morgan State Lady Bears": 'MORG', "Morningside Chiefs": 'MNGS', "Mount St Joseph Lions": 'MSJ',
  "Mount St. Mary's Mountaineers": 'MSM', "Mount Union Purple Raiders": 'UMU', "Muhlenberg Mules": 'MUHL',
  "Murray State Racers": 'MUR', "Muskingum Fighting Muskies": 'MSK', "NC State Wolfpack": 'NCSU',
  "NJIT Highlanders": 'NJIT', "Navy Midshipmen": 'NAVY', "Nebraska Cornhuskers": 'NEB',
  "Nebraska Kearney Lopers": 'NEBK', "Nebraska Wesleyan Prairie Wolves": 'NWU', "Nelson (TX) Lions": 'NEL',
  "Nevada Wolf Pack": 'NEV', "New England Nor'easters": 'UNE', "New Hampshire Wildcats": 'UNH',
  "New Haven Chargers": 'NHVN', "New Mexico Highlands Cowboys": 'NMHU', "New Mexico Lobos": 'UNM',
  "New Mexico State Aggies": 'NMSU', "Newberry Wolves": 'NBRY', "Niagara Purple Eagles": 'NIA',
  "Nicholls Colonels": 'NICH', "Nichols Bison": 'NICC', "Norfolk State Spartans": 'NORF',
  "North Alabama Lions": 'UNA', "North American Stallions": 'NAMU', "North Carolina A&T Aggies": 'NCAT',
  "North Carolina Central Eagles": 'NCCU', "North Carolina Tar Heels": 'UNC', "North Carolina Wesleyan Battling Bishops": 'NCW',
  "North Central College Cardinals": 'NCC', "North Dakota Fighting Hawks": 'UND', "North Dakota State Bison": 'NDSU',
  "North Florida Ospreys": 'UNF', "North Greenville Trailblazers": 'NGU', "North Park Vikings": 'NPU',
  "North Texas Mean Green": 'UNT', "Northeastern Huskies": 'NE', "Northeastern State RiverHawks": 'NESU',
  "Northern Arizona Lumberjacks": 'NAU', "Northern Colorado Bears": 'UNCO', "Northern Illinois Huskies": 'NIU',
  "Northern Iowa Panthers": 'UNI', "Northern Kentucky Norse": 'NKU', "Northern Michigan Wildcats": 'NMI',
  "Northern State Wolves": 'NSU', "Northwest Missouri State Bearcats": 'MWMO', "Northwestern (MN) Eagles": 'UNW',
  "Northwestern (OK) Rangers": 'NWOK', "Northwestern State Demons": 'NWST', "Northwestern State Lady Demons": 'NWST',
  "Northwestern Wildcats": 'NU', "Northwood Timberwolves": 'NWD', "Norwich Cadets": 'NWCH',
  "Notre Dame Fighting Irish": 'ND', "Oakland Golden Grizzlies": 'OAK', "Oberlin Yeomen": 'OBE',
  "Ohio Bobcats": 'OHIO', "Ohio Northern Polar Bears": 'OHNU', "Ohio State Buckeyes": 'OSU',
  "Ohio State Newark Titans": 'OSU', "Ohio Wesleyan Battling Bishops": 'OWU', "Oklahoma Baptist Bison": 'OKBU',
  "Oklahoma Panhandle OK PANHANDLE ST": 'OPSU', "Oklahoma Sooners": 'OU', "Oklahoma State Cowboys": 'OKST',
  "Oklahoma State Cowgirls": 'OKST', "Old Dominion Monarchs": 'ODU', "Ole Miss Rebels": 'MISS',
  "Olivet Comets": 'UOO', "Omaha Mavericks": 'OMA', "Oral Roberts Golden Eagles": 'ORU',
  "Oregon Ducks": 'ORE', "Oregon State Beavers": 'ORST', "Otterbein Cardinals": 'OTTB',
  "Ouachita Baptist Tigers": 'OBU', "Pace Setters": 'PACE', "Pacific (OR) Boxers": 'PCOR',
  "Pacific Lutheran Lutes": 'PCLT', "Pacific Tigers": 'PAC', "Penn State Lady Lions": 'PSU',
  "Penn State Nittany Lions": 'PSU', "Pennsylvania Quakers": 'PENN', "Pepperdine Waves": 'PEPP',
  "Phoenix Firestorm": 'AZCH', "Pikeville Bears": 'PIKEV', "Pittsburg State Gorillas": 'PTSU',
  "Pittsburgh Panthers": 'PITT', "Plymouth State Panthers": 'PLYM', "Point University Skyhawks": 'POINT',
  "Pomona Pitzer Sagehens": 'POPI', "Portland Pilots": 'PORT', "Portland State Vikings": 'PRST',
  "Post Eagles": 'POST', "Prairie View A&M Lady Panthers": 'PV', "Prairie View A&M Panthers": 'PV',
  "Presbyterian Blue Hose": 'PRES', "Princeton Tigers": 'PRIN', "Providence Friars": 'PROV',
  "Puget Sound Loggers": 'PUG', "Purdue Boilermakers": 'PUR', "Purdue Fort Wayne Mastodons": 'PFW',
  "Quincy Hawks": 'QUI', "Quinnipiac Bobcats": 'QUIN', "Radford Highlanders": 'RAD',
  "Randolph Macon Yellow Jackets": 'RMC', "Redlands Bulldogs": 'REDL', "Reinhardt Eagles": 'RHDT',
  "Rensselaer Engineers": 'RPI', "Rhode Island Rams": 'URI', "Rhodes Lynx": 'RHDS',
  "Rice Owls": 'RICE', "Richmond Spiders": 'RICH', "Rider Broncs": 'RID',
  "Ripon Red Hawks": 'RIP', "Robert Morris Colonials": 'RMU', "Rochester (NY) Yellow Jackets": 'URNY',
  "Rockford Regents": 'RFU', "Roosevelt Lakers": 'RSVT', "Rose Hulman Fightin' Engineers": 'RHIT',
  "Rowan Profs": 'ROW', "Rutgers Scarlet Knights": 'RUTG', "SE Louisiana Lady Lions": 'SELA',
  "SE Louisiana Lions": 'SELA', "SIU Edwardsville Cougars": 'SIUE', "SMU Mustangs": 'SMU',
  "SUNY Cortland Red Dragons": 'NYCL', "SUNY Erie Kats": 'NYER', "SUNY Maritime Privateers": 'NYMT',
  "SUNY Morrisville Mustangs": 'NYMS', "Sacramento State Hornets": 'SAC', "Sacred Heart Pioneers": 'SHU',
  "Saginaw Valley State Cardinals": 'SVSU', "Saint Anselm Hawks": 'SANS', "Saint Francis (IN) Cougars": 'SFIN',
  "Saint Francis Red Flash": 'SFPA', "Saint John's (MN) Johnnies": 'STJM', "Saint Joseph's Hawks": 'JOES',
  "Saint Louis Billikens": 'SLU', "Saint Mary's Gaels": 'SMC', "Saint Peter's Peacocks": 'SPU',
  "Saint Vincent Bearcats": 'SVC', "Saint Xavier Cougars": 'STX', "Salisbury Sea Gulls": 'SAL',
  "Salve Regina Seahawks": 'SALV', "Sam Houston Bearkats": 'SHSU', "Samford Bulldogs": 'SAM',
  "San Diego State Aztecs": 'SDSU', "San Diego Toreros": 'USD', "San Francisco Dons": 'SF',
  "San José State Spartans": 'SJSU', "Santa Clara Broncos": 'SCU', "Savannah State Tigers": 'SAV',
  "Seattle U Redhawks": 'SEA', "Seton Hall Pirates": 'HALL', "Seton Hill Griffins": 'SEHI',
  "Sewanee Tigers": 'SEWA', "Shaw Bears": 'SHAW', "Shenandoah Hornets": 'SHEN',
  "Shepherd Rams": 'SHEP', "Shippensburg Raiders": 'SHIP', "Shorter Hawks": 'SHOU',
  "Siena Heights Saints": 'SHTU', "Siena Saints": 'SIE', "Simpson (CA) Red Hawks": 'SUCA',
  "Simpson (IA) Storm": 'SCIA', "Sioux Falls Cougars": 'SFU', "Slippery Rock The Rock": 'SRU',
  "South Alabama Jaguars": 'USA', "South Carolina Gamecocks": 'SC', "South Carolina State Bulldogs": 'SCST',
  "South Carolina State Lady Bulldogs": 'SCST', "South Carolina Upstate Spartans": 'UPST', "South Dakota Coyotes": 'SDAK',
  "South Dakota Mines Hardrockers": 'SDMT', "South Dakota State Jackrabbits": 'SDST', "South Florida Bulls": 'USF',
  "Southeast Missouri State Redhawks": 'SEMO', "Southeastern Fires": 'SEU', "Southeastern Oklahoma State Savage Storm": 'SEOK',
  "Southern Arkansas Muleriders": 'SAR', "Southern Connecticut State Owls": 'SCTS', "Southern Illinois Salukis": 'SIU',
  "Southern Jaguars": 'SOU', "Southern Miss Golden Eagles": 'USM', "Southern Miss Lady Eagles": 'USM',
  "Southern Nazarene Crimson Storm": 'SNU', "Southern Oregon Raiders": 'SOR', "Southern Utah Thunderbirds": 'SUU',
  "Southern Virginia Knights": 'SOVA', "Southwest Baptist Bearcats": 'SWBU', "Southwest Minnesota State Mustangs": 'SWMS',
  "Southwestern (KS) Moundbuilders": 'SWKS', "Southwestern Oklahoma State Bulldogs": 'SOSU', "Southwestern U Pirates": 'SWU',
  "Springfield Pride": 'SPR', "St. Ambrose Fighting Bees": 'STAM', "St. Andrews Knights": 'STAU',
  "St. Bonaventure Bonnies": 'SBU', "St. Francis (IL) Fighting Saints": 'SFIL', "St. John Fisher Cardinals": 'STJF',
  "St. John's Red Storm": 'SJU', "St. Lawrence Saints": 'USL', "St. Norbert Green Knights": 'STNC',
  "St. Olaf Oles": 'OLAF', "St. Petersburg Glory Eagles": 'UFFL', "St. Scholastica Saints": 'CSS',
  "St. Thomas Tommies": 'STMN', "Stanford Cardinal": 'STAN', "Stephen F. Austin Ladyjacks": 'SFA',
  "Stephen F. Austin Lumberjacks": 'SFA', "Sterling STERLING KS": 'STLG', "Stetson Hatters": 'STET',
  "Stevenson Mustangs": 'STVS', "Stonehill Skyhawks": 'STO', "Stony Brook Seawolves": 'STBK',
  "Sul Ross State Lobos": 'SRST', "Susquehanna River Hawks": 'SUSQ', "Syracuse Orange": 'SYR',
  "TCU Horned Frogs": 'TCU', "Tarleton State Texans": 'TAR', "Taylor Trojans": 'TLRU',
  "Temple Owls": 'TEM', "Tennessee Lady Volunteers": 'TENN', "Tennessee State Lady Tigers": 'TNST',
  "Tennessee State Tigers": 'TNST', "Tennessee Tech Golden Eagles": 'TNTC', "Tennessee Volunteers": 'TENN',
  "Texas A&M Aggies": 'TA&M', "Texas A&M-Corpus Christi Islanders": 'AMCC', "Texas A&M-Kingsville Javelinas": 'TAMK',
  "Texas College Steers": 'TXCL', "Texas Longhorns": 'TEX', "Texas Lutheran Bulldogs": 'TXLU',
  "Texas Southern Tigers": 'TXSO', "Texas State Bobcats": 'TXST', "Texas Tech Lady Raiders": 'TTU',
  "Texas Tech Red Raiders": 'TTU', "The Citadel Bulldogs": 'CIT', "The College of New Jersey Lions": 'TCNJ',
  "Thiel Tomcats": 'THI', "Thomas More Saints": 'TMOR', "Thomas Night Hawks": 'THO',
  "Tiffin Dragons": 'TIFF', "Toledo Rockets": 'TOL', "Towson Tigers": 'TOW',
  "Trine Thunder": 'TRNE', "Trinity (CT) Bantams": 'TCCT', "Trinity (TX) Tigers": 'TUTX',
  "Trinity Bible Lions": 'TBIB', "Troy Trojans": 'TROY', "Troy Vikings": 'HVCC',
  "Truman State Bulldogs": 'TRST', "Tufts Jumbos": 'TUFT', "Tulane Green Wave": 'TULN',
  "Tulsa Golden Hurricane": 'TLSA', "Tusculum Pioneers": 'TUSC', "Tuskegee Golden Tigers": 'TUSK',
  "UAB Blazers": 'UAB', "UAlbany Great Danes": 'UALB', "UC Davis Aggies": 'UCD',
  "UC Irvine Anteaters": 'UCI', "UC Riverside Highlanders": 'UCR', "UC San Diego Tritons": 'UCSD',
  "UC Santa Barbara Gauchos": 'UCSB', "UCF Knights": 'UCF', "UCLA Bruins": 'UCLA',
  "UConn Huskies": 'CONN', "UIC Flames": 'UIC', "UL Monroe Warhawks": 'ULM',
  "UMBC Retrievers": 'UMBC', "UMass Dartmouth Corsairs": 'MDAR', "UMass Lowell River Hawks": 'UML',
  "UNC Asheville Bulldogs": 'UNCA', "UNC Greensboro Spartans": 'UNCG', "UNC Pembroke Braves": 'UNCP',
  "UNC Wilmington Seahawks": 'UNCW', "UNLV Lady Rebels": 'UNLV', "UNLV Rebels": 'UNLV',
  "USC Trojans": 'USC', "UT Arlington Mavericks": 'UTA', "UT Martin Skyhawks": 'UTM',
  "UT Permian Basin Falcons": 'UTPB', "UT Rio Grande Valley Vaqueros": 'RGV', "UTEP Miners": 'UTEP',
  "UTSA Roadrunners": 'UTSA', "UVA Wise Cavaliers": 'UVAW', "Union Garnet Chargers": 'UNNY',
  "University of Mary Marauders": 'MARY', "University of Mexico MEXICO U": 'UNAM', "Upper Iowa Peacocks": 'UIU',
  "Ursinus Bears": 'URSN', "Utah State Aggies": 'USU', "Utah Tech Trailblazers": 'UTU',
  "Utah Utes": 'UTAH', "Utah Valley Wolverines": 'UVU', "Utica Pioneers": 'UTIC',
  "VCU Rams": 'VCU', "VMI Keydets": 'VMI', "Valdosta State Blazers": 'VALD',
  "Valley City State VALLEY CITY ST": 'VCSU', "Valparaiso Beacons": 'VAL', "Vanderbilt Commodores": 'VAN',
  "Vermont Catamounts": 'UVM', "Vermont State Castleton Spartans": 'VTSC', "Villanova Wildcats": 'VILL',
  "Virginia Cavaliers": 'UVA', "Virginia Lynchburg Dragons": 'VUL', "Virginia State Trojans": 'VSU',
  "Virginia Tech Hokies": 'VT', "Virginia Union Panthers": 'VUU', "WPI Engineers": 'WPI',
  "WVU Tech Golden Bears": 'WVUT', "Wabash Little Giants": 'WAB', "Wagner Seahawks": 'WAG',
  "Wake Forest Demon Deacons": 'WAKE', "Waldorf Warriors": 'WLDF', "Walsh Cavaliers": 'WLSH',
  "Warner Royals": 'WRNR', "Wartburg Knights": 'WTBG', "Washburn Ichabods": 'WSBN',
  "Washington & Jefferson Presidents": 'W&J', "Washington Huskies": 'WASH', "Washington St. Louis Bears": 'WUMO',
  "Washington State Cougars": 'WSU', "Washington and Lee Generals": 'W&L', "Wayland Baptist Pioneers": 'WYBU',
  "Wayne State (MI) Warriors": 'WSMI', "Wayne State (NE) Wildcats": 'WSNE', "Waynesburg Yellow Jackets": 'WAYN',
  "Webber International Warriors": 'WINT', "Weber State Wildcats": 'WEB', "Wesleyan (CT) Cardinals": 'WSCT',
  "West Alabama Tigers": 'UWA', "West Chester Golden Rams": 'WCHT', "West Florida Argonauts": 'UWF',
  "West Georgia Wolves": 'WGA', "West Liberty Hilltoppers": 'WLU', "West Memphis Crusaders": 'FAI',
  "West Texas Buffaloes": 'WTAM', "West Virginia Mountaineers": 'WVU', "West Virginia State Yellow Jackets": 'WVSU',
  "West Virginia Wesleyan Bobcats": 'WVWC', "Western Carolina Catamounts": 'WCU', "Western Colorado Mountaineers": 'WCOL',
  "Western Connecticut State Wolves": 'WCSU', "Western Illinois Leathernecks": 'WIU', "Western Kentucky Hilltoppers": 'WKU',
  "Western Kentucky Lady Toppers": 'WKU', "Western Michigan Broncos": 'WMU', "Western New England Golden Bears": 'WNE',
  "Western New Mexico Mustangs": 'WNMU', "Western Oregon Wolves": 'WORU', "Westfield State Owls": 'WFST',
  "Westgate Christian University Ravens": 'WES', "Westminster (MO) Blue Jays": 'WCMO', "Westminster (PA) Titans": 'WCPA',
  "Wheaton (IL) Thunder": 'WCIL', "Wheeling Cardinals": 'WHLG', "Whittier Poets": 'WHTR',
  "Whitworth Pirates": 'WHIW', "Wichita State Shockers": 'WICH', "Widener Pride": 'WIDE',
  "Wilkes Colonels": 'WILK', "Willamette Bearcats": 'WLMT', "William & Mary Tribe": 'W&M',
  "William Jewell Cardinals": 'WJC', "William Paterson Pioneers": 'WPU', "William Penn Statesmen": 'WPEN',
  "Williams Ephs": 'WLM', "Williamson Mechanics": 'WMSN', "Wilmington (OH) Fightin' Quakers": 'WCOH',
  "Wingate Bulldogs": 'WINU', "Winona State Warriors": 'WNST', "Winston-Salem State Rams": 'WSSU',
  "Winthrop Eagles": 'WIN', "Wisconsin Badgers": 'WIS', "Wisconsin Eau Claire Blugolds": 'UWEC',
  "Wisconsin La Crosse Eagles": 'UWL', "Wisconsin Lutheran Warriors": 'WLC', "Wisconsin Oshkosh Titans": 'UWO',
  "Wisconsin Platteville Pioneers": 'UWP', "Wisconsin River Falls Falcons": 'UWRF', "Wisconsin Stevens Point Pointers": 'UWSP',
  "Wisconsin Stout Blue Devils": 'UWST', "Wisconsin Whitewater Warhawks": 'UWW', "Wittenberg Tigers": 'WITT',
  "Wofford Terriers": 'WOF', "Wooster Fighting Scots": 'WOO', "Worcester State Lancers": 'WORC',
  "Wright State Raiders": 'WRST', "Wyoming Cowboys": 'WYO', "Wyoming Cowgirls": 'WYO',
  "Xavier Musketeers": 'XAV', "Yale Bulldogs": 'YALE', "Youngstown State Penguins": 'YSU',
}

const UFL_ABBRS = {
  'Birmingham Stallions': 'bham', 'Columbus Aviators': 'clb',
  'DC Defenders': 'dc', 'DC DEFENDERS': 'dc',
  'Dallas Renegades': 'dal', 'Houston Gamblers': 'hou',
  'Louisville Kings': 'lou', 'Orlando Storm': 'orl',
  'St. Louis Battlehawks': 'stl', 'St Louis Battlehawks': 'stl',
}

// MLS team → ESPN numeric ID (same pattern as NCAA). Includes name
// variants for teams whose odds-API/DB name differs from ESPN's
// display name (Red Bull New York vs New York Red Bulls, unaccented
// Montreal, unofficial St Louis casing).
const MLS_IDS = {
  'Atlanta United FC': '18418', 'Atlanta United': '18418',
  'Austin FC': '20906',
  'CF Montréal': '9720', 'CF Montreal': '9720',
  'Charlotte FC': '21300',
  'Chicago Fire FC': '182', 'Chicago Fire': '182',
  'Colorado Rapids': '184',
  'Columbus Crew': '183',
  'Columbus Crew SC': '183',
  'D.C. United': '193', 'DC United': '193',
  'FC Cincinnati': '18267',
  'FC Dallas': '185',
  'Houston Dynamo FC': '6077', 'Houston Dynamo': '6077',
  'Inter Miami CF': '20232', 'Inter Miami': '20232',
  'LA Galaxy': '187',
  'LAFC': '18966', 'Los Angeles FC': '18966',
  'Minnesota United FC': '17362', 'Minnesota United': '17362',
  'Nashville SC': '18986',
  'New England Revolution': '189',
  'New York City FC': '17606', 'NYC FC': '17606', 'NYCFC': '17606',
  'Orlando City SC': '12011', 'Orlando City': '12011',
  'Philadelphia Union': '10739',
  'Portland Timbers': '9723',
  'Real Salt Lake': '4771',
  'Red Bull New York': '190', 'New York Red Bulls': '190',
  'San Diego FC': '22529',
  'San Jose Earthquakes': '191',
  'Seattle Sounders FC': '9726', 'Seattle Sounders': '9726',
  'Sporting Kansas City': '186', 'Sporting KC': '186',
  'St. Louis CITY SC': '21812', 'St. Louis City SC': '21812', 'St Louis City SC': '21812',
  'Toronto FC': '7318',
  'Vancouver Whitecaps': '9727', 'Vancouver Whitecaps FC': '9727',
}

const SPORT_MAP = {
  icehockey_nhl: { abbrs: NHL_ABBRS, sport: 'nhl' },
  basketball_nba: { abbrs: NBA_ABBRS, sport: 'nba' },
  baseball_mlb: { abbrs: MLB_ABBRS, sport: 'mlb' },
  americanfootball_nfl: { abbrs: NFL_ABBRS, sport: 'nfl' },
  // Preseason NFL games use the same team abbreviations as the regular
  // season — Panthers are Panthers either way — so we reuse NFL_ABBRS.
  // Without this entry, preseason game cards would silently render
  // without logos even though every other NFL/WNBA/MLB/NBA card has them.
  americanfootball_nfl_preseason: { abbrs: NFL_ABBRS, sport: 'nfl' },
  basketball_wnba: { abbrs: WNBA_ABBRS, sport: 'wnba' },
  americanfootball_ufl: { abbrs: UFL_ABBRS, sport: 'ufl' },
  americanfootball_ncaaf: { ids: NCAA_IDS, sport: 'ncaa' },
  basketball_ncaab: { ids: NCAA_IDS, sport: 'ncaa' },
  basketball_wncaab: { ids: NCAA_IDS, sport: 'ncaa' },
  // MLS uses ESPN numeric team IDs, under the `soccer` sport folder.
  soccer_usa_mls: { ids: MLS_IDS, sport: 'soccer' },
}

// Canonical 3-letter team abbreviations for display (e.g. prop card
// headers). Distinct from the logo-URL slugs above because ESPN's logo
// CDN uses shorter codes (gs, ny, no, sa, la, sj, tb) than the standard
// sports-broadcast abbreviations (GSW, NYK, NOP, SAS, LAK, SJS, TBL).
// Names are unique strings across sports so no sport key is needed.
const CANONICAL_ABBRS = {
  // NBA
  'Atlanta Hawks': 'ATL', 'Boston Celtics': 'BOS', 'Brooklyn Nets': 'BKN',
  'Charlotte Hornets': 'CHA', 'Chicago Bulls': 'CHI', 'Cleveland Cavaliers': 'CLE',
  'Dallas Mavericks': 'DAL', 'Denver Nuggets': 'DEN', 'Detroit Pistons': 'DET',
  'Golden State Warriors': 'GSW', 'Houston Rockets': 'HOU', 'Indiana Pacers': 'IND',
  'LA Clippers': 'LAC', 'Los Angeles Clippers': 'LAC', 'Los Angeles Lakers': 'LAL',
  'LA Lakers': 'LAL', 'Memphis Grizzlies': 'MEM', 'Miami Heat': 'MIA',
  'Milwaukee Bucks': 'MIL', 'Minnesota Timberwolves': 'MIN', 'New Orleans Pelicans': 'NOP',
  'New York Knicks': 'NYK', 'Oklahoma City Thunder': 'OKC', 'Orlando Magic': 'ORL',
  'Philadelphia 76ers': 'PHI', 'Phoenix Suns': 'PHX', 'Portland Trail Blazers': 'POR',
  'Sacramento Kings': 'SAC', 'San Antonio Spurs': 'SAS', 'Toronto Raptors': 'TOR',
  'Utah Jazz': 'UTA', 'Washington Wizards': 'WAS',
  // NHL
  'Anaheim Ducks': 'ANA', 'Arizona Coyotes': 'ARI', 'Boston Bruins': 'BOS',
  'Buffalo Sabres': 'BUF', 'Calgary Flames': 'CGY', 'Carolina Hurricanes': 'CAR',
  'Chicago Blackhawks': 'CHI', 'Colorado Avalanche': 'COL', 'Columbus Blue Jackets': 'CBJ',
  'Dallas Stars': 'DAL', 'Detroit Red Wings': 'DET', 'Edmonton Oilers': 'EDM',
  'Florida Panthers': 'FLA', 'Los Angeles Kings': 'LAK', 'Minnesota Wild': 'MIN',
  'Montreal Canadiens': 'MTL', 'Montréal Canadiens': 'MTL',
  'Nashville Predators': 'NSH', 'New Jersey Devils': 'NJD',
  'New York Islanders': 'NYI', 'New York Rangers': 'NYR', 'Ottawa Senators': 'OTT',
  'Philadelphia Flyers': 'PHI', 'Pittsburgh Penguins': 'PIT', 'San Jose Sharks': 'SJS',
  'Seattle Kraken': 'SEA', 'St. Louis Blues': 'STL', 'St Louis Blues': 'STL',
  'Tampa Bay Lightning': 'TBL', 'Toronto Maple Leafs': 'TOR',
  'Utah Hockey Club': 'UTA', 'Utah Mammoth': 'UTA',
  'Vancouver Canucks': 'VAN', 'Vegas Golden Knights': 'VGK', 'Washington Capitals': 'WSH',
  'Winnipeg Jets': 'WPG',
  // MLB
  'Arizona Diamondbacks': 'ARI', 'Atlanta Braves': 'ATL', 'Baltimore Orioles': 'BAL',
  'Boston Red Sox': 'BOS', 'Chicago Cubs': 'CHC', 'Chicago White Sox': 'CHW',
  'Cincinnati Reds': 'CIN', 'Cleveland Guardians': 'CLE', 'Colorado Rockies': 'COL',
  'Detroit Tigers': 'DET', 'Houston Astros': 'HOU', 'Kansas City Royals': 'KC',
  'Los Angeles Angels': 'LAA', 'Los Angeles Dodgers': 'LAD', 'Miami Marlins': 'MIA',
  'Milwaukee Brewers': 'MIL', 'Minnesota Twins': 'MIN', 'New York Mets': 'NYM',
  'New York Yankees': 'NYY', 'Oakland Athletics': 'ATH', 'Athletics': 'ATH',
  'Philadelphia Phillies': 'PHI', 'Pittsburgh Pirates': 'PIT', 'San Diego Padres': 'SD',
  'San Francisco Giants': 'SF', 'Seattle Mariners': 'SEA',
  'St. Louis Cardinals': 'STL', 'St Louis Cardinals': 'STL',
  'Tampa Bay Rays': 'TB', 'Texas Rangers': 'TEX', 'Toronto Blue Jays': 'TOR',
  'Washington Nationals': 'WSH',
  // NFL
  'Arizona Cardinals': 'ARI', 'Atlanta Falcons': 'ATL', 'Baltimore Ravens': 'BAL',
  'Buffalo Bills': 'BUF', 'Carolina Panthers': 'CAR', 'Chicago Bears': 'CHI',
  'Cincinnati Bengals': 'CIN', 'Cleveland Browns': 'CLE', 'Dallas Cowboys': 'DAL',
  'Denver Broncos': 'DEN', 'Detroit Lions': 'DET', 'Green Bay Packers': 'GB',
  'Houston Texans': 'HOU', 'Indianapolis Colts': 'IND', 'Jacksonville Jaguars': 'JAX',
  'Kansas City Chiefs': 'KC', 'Las Vegas Raiders': 'LV', 'Los Angeles Chargers': 'LAC',
  'Los Angeles Rams': 'LAR', 'Miami Dolphins': 'MIA', 'Minnesota Vikings': 'MIN',
  'New England Patriots': 'NE', 'New Orleans Saints': 'NO', 'New York Giants': 'NYG',
  'New York Jets': 'NYJ', 'Philadelphia Eagles': 'PHI', 'Pittsburgh Steelers': 'PIT',
  'San Francisco 49ers': 'SF', 'Seattle Seahawks': 'SEA', 'Tampa Bay Buccaneers': 'TB',
  'Tennessee Titans': 'TEN', 'Washington Commanders': 'WSH',
  // WNBA
  'Atlanta Dream': 'ATL', 'Chicago Sky': 'CHI', 'Connecticut Sun': 'CONN',
  'Dallas Wings': 'DAL', 'Golden State Valkyries': 'GSV', 'Indiana Fever': 'IND',
  'Las Vegas Aces': 'LV', 'Los Angeles Sparks': 'LA', 'Minnesota Lynx': 'MIN',
  'New York Liberty': 'NY', 'Phoenix Mercury': 'PHX', 'Portland Fire': 'POR',
  'Seattle Storm': 'SEA', 'Toronto Tempo': 'TOR', 'Washington Mystics': 'WAS',
  // UFL
  'Birmingham Stallions': 'BHM', 'Columbus Aviators': 'CLB',
  'DC Defenders': 'DC', 'DC DEFENDERS': 'DC',
  'Dallas Renegades': 'DAL', 'Houston Gamblers': 'HOU',
  'Louisville Kings': 'LOU', 'Orlando Storm': 'ORL',
  'St. Louis Battlehawks': 'STL', 'St Louis Battlehawks': 'STL',
}

// Normalize team names to a form that matches across sources:
// strip diacritics ("San José" → "San Jose"), fold curly quotes /
// ʻokina to straight ("Hawai'i" → "hawai'i" → "hawaii"), collapse
// whitespace, lowercase. Odds sources spell "San Jose State" while
// ESPN spells "San José State" — this bridges the two.
function normalizeName(s) {
  if (!s) return ''
  return s
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[ʻʼ‘’]/g, "'")
    .replace(/'/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .split(' ')
    // Bare "St" means STATE; "St." with the period means SAINT. The odds
    // feed spells 45 schools "Michigan St", "Florida St", "San José St"
    // while our logo map carries them as "... State", so without this 15%
    // of the NCAAB board renders with no crest. NCAAF hides the problem
    // almost completely — exactly one of its 231 names uses bare "St" —
    // which is why San José State had a football logo and no basketball
    // one, the report that surfaced this.
    //
    // The period is a clean discriminator across the whole feed: every
    // Saint school ships it ("St. John's", "St. Bonaventure", and the
    // trap, "Mt. St. Mary's", where it sits MID-name), and every State
    // school omits it. The first token is never expanded, so "St Louis
    // Battlehawks" is untouched.
    //
    // Measured over the live NCAAB board: logo resolution 78.1% -> 90.4%,
    // 45 schools gained, 0 new key collisions across all three maps. It
    // cannot regress a working match — the same transform runs over the
    // map keys and the lookup name, so any pair equal before is equal
    // after. That symmetry is also why "Mount St Joseph" normalizing to
    // the nonsense "mount state joseph" is harmless rather than a bug.
    .map((word, i) => (i > 0 && word === 'st' ? 'state' : word))
    .join(' ')
}

// Feed spellings that no normalization rule can reach: abbreviations
// ("CSU Fullerton", "UMKC", "GW"), parenthetical qualifiers ("Loyola (Chi)"),
// and schools whose canonical name shares no words with the feed's
// ("Grand Canyon Antelopes" -> "Grand Canyon Lopes", "Long Beach St 49ers"
// -> "Long Beach State Beach", "UMKC Kangaroos" -> "Kansas City Roos").
//
// Deliberately an explicit table rather than fuzzy matching. Mascots repeat
// constantly in college sport -- there are dozens of Bulldogs, Panthers and
// Tigers -- so anything that guesses by mascot WILL eventually attach the
// wrong school's crest, which is worse than no crest at all. Each line here
// was checked against the canonical key by school identity, not by mascot.
//
// Targets are the men's programmes where the map also carries a women's
// entry ("Grambling Tigers", not "Grambling Lady Tigers").
const NCAA_NAME_ALIASES = {
  'Albany Great Danes': 'UAlbany Great Danes',
  'American Eagles': 'American University Eagles',
  'Arkansas-Little Rock Trojans': 'Little Rock Trojans',
  'Army Knights': 'Army Black Knights',
  'Boston Univ. Terriers': 'Boston University Terriers',
  'CSU Bakersfield Roadrunners': 'Cal State Bakersfield Roadrunners',
  'CSU Fullerton Titans': 'Cal State Fullerton Titans',
  'CSU Northridge Matadors': 'Cal State Northridge Matadors',
  'Cal Baptist Lancers': 'California Baptist Lancers',
  'Central Connecticut St Blue Devils': 'Central Connecticut Blue Devils',
  "Florida Int'l Golden Panthers": 'Florida International Panthers',
  'Fort Wayne Mastodons': 'Purdue Fort Wayne Mastodons',
  'GW Revolutionaries': 'George Washington Revolutionaries',
  'Gardner-Webb Bulldogs': "Gardner-Webb Runnin' Bulldogs",
  'Grambling St Tigers': 'Grambling Tigers',
  'Grand Canyon Antelopes': 'Grand Canyon Lopes',
  'IUPUI Jaguars': 'IU Indianapolis Jaguars',
  'Long Beach St 49ers': 'Long Beach State Beach',
  'Loyola (Chi) Ramblers': 'Loyola Chicago Ramblers',
  'Loyola (MD) Greyhounds': 'Loyola Maryland Greyhounds',
  'Maryland-Eastern Shore Hawks': 'Maryland Eastern Shore Hawks',
  'Miss Valley St Delta Devils': 'Mississippi Valley State Delta Devils',
  "Mt. St. Mary's Mountaineers": "Mount St. Mary's Mountaineers",
  'N Colorado Bears': 'Northern Colorado Bears',
  'New Orleans Privateers': 'LSU New Orleans Privateers',
  'Prairie View Panthers': 'Prairie View A&M Panthers',
  'SE Missouri St Redhawks': 'Southeast Missouri State Redhawks',
  'SIU-Edwardsville Cougars': 'SIU Edwardsville Cougars',
  'Seattle Redhawks': 'Seattle U Redhawks',
  'St. Francis (PA) Red Flash': 'Saint Francis Red Flash',
  'St. Thomas (MN) Tommies': 'St. Thomas Tommies',
  'Tenn-Martin Skyhawks': 'UT Martin Skyhawks',
  'Texas A&M-CC Islanders': 'Texas A&M-Corpus Christi Islanders',
  'UMKC Kangaroos': 'Kansas City Roos',
  'UT-Arlington Mavericks': 'UT Arlington Mavericks',
}

let _aliasByNorm = null
function aliasFor(teamName) {
  if (!_aliasByNorm) {
    _aliasByNorm = {}
    for (const [feed, canon] of Object.entries(NCAA_NAME_ALIASES)) {
      _aliasByNorm[normalizeName(feed)] = canon
    }
  }
  return _aliasByNorm[normalizeName(teamName)] || null
}

// Lazy per-map cache of { normalizedKey -> originalValue } so a
// normalize-fallback lookup doesn't rebuild the reverse map every call.
const _normCache = new WeakMap()
function normalizedLookup(map, teamName) {
  if (!map || !teamName) return null
  const direct = map[teamName]
  if (direct != null) return direct
  let cached = _normCache.get(map)
  if (!cached) {
    cached = {}
    for (const k of Object.keys(map)) cached[normalizeName(k)] = map[k]
    _normCache.set(map, cached)
  }
  const hit = cached[normalizeName(teamName)]
  if (hit != null) return hit
  // Last resort: an explicit feed-spelling alias. Runs after normalization
  // so a rule-reachable name never pays for the lookup.
  const alias = aliasFor(teamName)
  return alias ? (cached[normalizeName(alias)] ?? null) : null
}

export function getTeamAbbr(teamName) {
  if (!teamName) return ''
  // Pro teams first — they are the smaller, hotter map — then college.
  return normalizedLookup(CANONICAL_ABBRS, teamName)
    || normalizedLookup(NCAA_ABBRS, teamName)
    || null
}

export function getTeamLogoUrl(teamName, sportKey) {
  // World Cup teams are countries — ESPN serves flags from a separate path
  // (i/teamlogos/countries/...) and there's no "dark" variant. Delegate to the
  // country-flag resolver so we don't end up looking for esp.png under nba/.
  if (sportKey === 'soccer_world_cup') {
    return getCountryFlagUrl(teamName)
  }
  const config = SPORT_MAP[sportKey]
  if (!config) return null
  // ESPN's "-dark" means "variant FOR dark backgrounds" — it's the LIGHT
  // artwork, which is what we want on our near-black UI. NCAA used to be
  // excluded here on the belief that -dark was the dark-on-transparent one;
  // measuring the actual images shows the opposite. Across an 18-team NCAA
  // sample, -dark was brighter for 14, identical for 4, and worse for none.
  // On the standard variant Iowa and Wake Forest average luminance 0 — they
  // render as literally invisible blobs. Ohio State sits at 52 with 45% of
  // its pixels near-black, which is what surfaced this.
  // getTeamLogoFallbackUrl still points at /500/ for the rare team with no
  // -dark artwork.
  const variant = '500-dark'
  if (config.ids) {
    const id = normalizedLookup(config.ids, teamName)
    if (!id) return null
    return `https://a.espncdn.com/i/teamlogos/${config.sport}/${variant}/${id}.png`
  }
  const abbr = normalizedLookup(config.abbrs, teamName)
  if (!abbr) return null
  return `https://a.espncdn.com/i/teamlogos/${config.sport}/${variant}/${abbr}.png`
}

// Standard (non-dark) URL as fallback
export function getTeamLogoFallbackUrl(teamName, sportKey) {
  if (sportKey === 'soccer_world_cup') {
    // Countries already use the standard (non-dark) URL — no fallback variant.
    return null
  }
  const config = SPORT_MAP[sportKey]
  if (!config) return null
  if (config.ids) {
    const id = normalizedLookup(config.ids, teamName)
    if (!id) return null
    return `https://a.espncdn.com/i/teamlogos/${config.sport}/500/${id}.png`
  }
  const abbr = normalizedLookup(config.abbrs, teamName)
  if (!abbr) return null
  return `https://a.espncdn.com/i/teamlogos/${config.sport}/500/${abbr}.png`
}
